/* tslint:disable */
/* eslint:disable */
/**
* @typedef {Object} connectModalystAccountToWixParams
* @property {string} accountId - modalyst account id
* @property {string} businessId - modalyst business id
* @property {string} instanceId - instanceId
* @property {boolean} isDebug - is debug mode
* @property {boolean} isPremium - is modalyst premium
* @property {string} origin - Ready to sell/wix tpa/...
* @property {string} retailerStorePlatform - retailer store platform
* @property {string} storeUrl - site's url. Null for Wix users
* @property {string} subscriptionPlanId - package id in modalyst definition
**/
/**
 * Name: Connect Modalyst account to Wix. Evid: 1001.
 * Event description: Connect modalyst account to wix.

 * accountId - Type: string. Desc: modalyst account id
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * instanceId - Type: string. Desc: instanceId
 *
 * isDebug - Type: bool. Desc: is debug mode
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * origin - Type: string. Desc: Ready to sell/wix tpa/...
 *
 * retailerStorePlatform - Type: string. Desc: retailer store platform
 *
 * storeUrl - Type: string. Desc: site's url. Null for Wix users
 *
 * subscriptionPlanId - Type: string. Desc: package id in modalyst definition
 * @param {connectModalystAccountToWixParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var connectModalystAccountToWix = function (params) {
    return { evid: 1001, src: 145, endpoint: 'modalyst', params: params };
};
/**
* @typedef {Object} addNewStoreClickedParams
* @property {string} accountId - modalyst account id
* @property {string} businessId - modalyst business id
* @property {string} correlationId - correlation_id
* @property {string} instanceId - instanceId
* @property {boolean} isDebug - is debug mode
* @property {boolean} isPremium - is modalyst premium
* @property {GUID} msid - msid
* @property {string} origin - my stores page / stores dropdown
* @property {string} retailerStorePlatform - retailer store platform
* @property {string} storeUrl - site's url. Null for Wix users
* @property {string} subscriptionPlanId - package id in modalyst definition
* @property {string} uuid - uuid
**/
/**
 * Name: Modalyst Multi-stores: Add New Store Clicked. Evid: 16.
 * Event description: Add New Store Clicked.

 * accountId - Type: string. Desc: modalyst account id
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * correlationId - Type: string. Desc: correlation_id
 *
 * instanceId - Type: string. Desc: instanceId
 *
 * isDebug - Type: bool. Desc: is debug mode
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my stores page / stores dropdown
 *
 * retailerStorePlatform - Type: string. Desc: retailer store platform
 *
 * storeUrl - Type: string. Desc: site's url. Null for Wix users
 *
 * subscriptionPlanId - Type: string. Desc: package id in modalyst definition
 *
 * uuid - Type: string. Desc: uuid
 * @param {addNewStoreClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addNewStoreClicked = function (params) {
    return { evid: 16, src: 145, endpoint: 'modalyst', params: params };
};
/**
* @typedef {Object} connectStoreModalNextClickedParams
* @property {string} accountId - modalyst account id
* @property {string} action - Shopify / Wix
* @property {string} businessId - modalyst business id
* @property {string} correlationId - correlation_id
* @property {string} instanceId - instanceId
* @property {boolean} isDebug - is debug mode
* @property {boolean} isPremium - is modalyst premium
* @property {GUID} msid - msid
* @property {string} retailerStorePlatform - retailer store platform
* @property {string} storeName - name of the store users try to connect
* @property {string} storeUrl - site's url. Null for Wix users
* @property {string} subscriptionPlanId - package id in modalyst definition
* @property {GUID} targetStoreId - id of the store users try to connect
* @property {string} uuid - uuid
**/
/**
 * Name: Modalyst Multi-stores: Store Connection modal -> Next Clicked. Evid: 31.
 * Event description: when user clicked next in the Store Connection modal.

 * accountId - Type: string. Desc: modalyst account id
 *
 * action - Type: string. Desc: Shopify / Wix
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * correlationId - Type: string. Desc: correlation_id
 *
 * instanceId - Type: string. Desc: instanceId
 *
 * isDebug - Type: bool. Desc: is debug mode
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * msid - Type: guid. Desc: msid
 *
 * retailerStorePlatform - Type: string. Desc: retailer store platform
 *
 * storeName - Type: string. Desc: name of the store users try to connect
 *
 * storeUrl - Type: string. Desc: site's url. Null for Wix users
 *
 * subscriptionPlanId - Type: string. Desc: package id in modalyst definition
 *
 * targetStoreId - Type: guid. Desc: id of the store users try to connect
 *
 * uuid - Type: string. Desc: uuid
 * @param {connectStoreModalNextClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var connectStoreModalNextClicked = function (params) {
    return { evid: 31, src: 145, endpoint: 'modalyst', params: params };
};
/**
* @typedef {Object} productSearchSearchAppliedParams
* @property {string} accountId - modalyst account id
* @property {number} batchSize - batch size - data mostly for dev
* @property {string} businessId - modalyst business id
* @property {string} categoryPath - List of categories user chosen (in order by hierarchy) - path
* @property {string} correlationId - correlation_id
* @property {number} duration - time from click to shown results
* @property {string} instanceId - instanceId
* @property {boolean} isDebug - is debug mode
* @property {boolean} isPremium - is modalyst premium
* @property {string} marketplace - RTS/POD
* @property {GUID} msid - wix msid
* @property {string} orderingType - ordering details
* @property {number} resultsNum - supplier_product_id
* @property {string} retailerStorePlatform - retailer store platform
* @property {string} searchTerm - search term
* @property {string} storeUrl - site's url. Null for Wix users
* @property {string} subscriptionPlanId - package id in modalyst definition
**/
/**
 * Name: Product Search: search applied. Evid: 1.
 * Event description: When search applied and the results are shown to user.

 * accountId - Type: string. Desc: modalyst account id
 *
 * batchSize - Type: numeric. Desc: batch size - data mostly for dev
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * categoryPath - Type: string. Desc: List of categories user chosen (in order by hierarchy) - path
 *
 * correlationId - Type: string. Desc: correlation_id
 *
 * duration - Type: numeric. Desc: time from click to shown results
 *
 * instanceId - Type: string. Desc: instanceId
 *
 * isDebug - Type: bool. Desc: is debug mode
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * marketplace - Type: string. Desc: RTS/POD
 *
 * msid - Type: guid. Desc: wix msid
 *
 * orderingType - Type: string. Desc: ordering details
 *
 * resultsNum - Type: numeric. Desc: supplier_product_id
 *
 * retailerStorePlatform - Type: string. Desc: retailer store platform
 *
 * searchTerm - Type: string. Desc: search term
 *
 * storeUrl - Type: string. Desc: site's url. Null for Wix users
 *
 * subscriptionPlanId - Type: string. Desc: package id in modalyst definition
 * @param {productSearchSearchAppliedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var productSearchSearchApplied = function (params) {
    return { evid: 1, src: 145, endpoint: 'modalyst', params: params };
};
/**
* @typedef {Object} removeProductClickedParams
* @property {string} accountId - modalyst account id
* @property {string} businessId - modalyst business id
* @property {string} correlationId - id to connect between client and server event
* @property {string} instanceId - instanceId
* @property {boolean} isBulk - is bulk action
* @property {boolean} isDebug - is debug mode
* @property {boolean} isPremium - is modalyst premium
* @property {string} marketplace - RTS/POD
* @property {string} modalystProductId - modalyst_product_id
* @property {string} modalystVariantIds - List of variant ids
* @property {GUID} msid - wix msid
* @property {string} origin - Import list/Synced products
* @property {string} productName - productName
* @property {string} retailerProductId - retailerProductId
* @property {string} retailerStorePlatform - retailer store platform
* @property {string} retailerVariantIds - List of retailer variants id
* @property {string} storeUrl - site's url. Null for Wix users
* @property {string} subscriptionPlanId - package id in modalyst definition
* @property {string} supplierId - supplier_id
* @property {string} supplierProductId - supplier Product Id
* @property {number} variantsCount - number of variants
**/
/**
 * Name: Remove Product Clicked. Evid: 6.
 * Event description: When user clicked to remove product from store.

 * accountId - Type: string. Desc: modalyst account id
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * correlationId - Type: string. Desc: id to connect between client and server event
 *
 * instanceId - Type: string. Desc: instanceId
 *
 * isBulk - Type: bool. Desc: is bulk action
 *
 * isDebug - Type: bool. Desc: is debug mode
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * marketplace - Type: string. Desc: RTS/POD
 *
 * modalystProductId - Type: string. Desc: modalyst_product_id
 *
 * modalystVariantIds - Type: string. Desc: List of variant ids
 *
 * msid - Type: guid. Desc: wix msid
 *
 * origin - Type: string. Desc: Import list/Synced products
 *
 * productName - Type: string. Desc: productName
 *
 * retailerProductId - Type: string. Desc: retailerProductId
 *
 * retailerStorePlatform - Type: string. Desc: retailer store platform
 *
 * retailerVariantIds - Type: string. Desc: List of retailer variants id
 *
 * storeUrl - Type: string. Desc: site's url. Null for Wix users
 *
 * subscriptionPlanId - Type: string. Desc: package id in modalyst definition
 *
 * supplierId - Type: string. Desc: supplier_id
 *
 * supplierProductId - Type: string. Desc: supplier Product Id
 *
 * variantsCount - Type: numeric. Desc: number of variants
 * @param {removeProductClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var removeProductClicked = function (params) {
    return { evid: 6, src: 145, endpoint: 'modalyst', params: params };
};
/**
* @typedef {Object} placeAnOrderClickedParams
* @property {string} accountId - modalyst account id
* @property {string} businessId - modalyst business id
* @property {string} correlationId - correlation_id
* @property {string} instanceId - instanceId
* @property {boolean} isDebug - is debug mode
* @property {boolean} isPremium - is modalyst premium
* @property {boolean} isShippingInCost - Is shipping included to cost
* @property {number} itemCost - Original cost
* @property {number} itemsQuantity - Total number of variants
* @property {string} marketplace - RTS/POD
* @property {string} modalystOrderId - Unique id from modalyst site
* @property {number} modalystOrderNumber - number that is displayed for user in interface
* @property {string} modalystProductId - modalyst_product_id
* @property {number} modalystServiceFee - Modalyst_service_fee (retailer)
* @property {string} modalystVariantIds - List of variant ids
* @property {GUID} bi_token - wix msid
* @property {number} numItems - Distinct variants
* @property {number} numProducts - Distinct products
* @property {string} origin - Import list/synced products list/product page
* @property {string} productName - product_name
* @property {string} retailerProductId - retailerProductId
* @property {string} retailerStorePlatform - retailer store platform
* @property {string} retailerVariantIds - List of retailer variants id
* @property {number} shippingRate - Shipping cost
* @property {string} storeUrl - site's url. Null for Wix users
* @property {string} subscriptionPlanId - package id in modalyst definition
* @property {string} supplierId - supplier Id
* @property {string} supplierProductId - supplier ProductI d
* @property {number} totalAmount - Retail order price (total price)
* @property {number} variantsCount - Number of variants in the order / sample order
**/
/**
 * Name: Place an order clicked. Evid: 12.
 * Event description: When user clicked place an order.

 * accountId - Type: string. Desc: modalyst account id
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * correlationId - Type: string. Desc: correlation_id
 *
 * instanceId - Type: string. Desc: instanceId
 *
 * isDebug - Type: bool. Desc: is debug mode
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * isShippingInCost - Type: bool. Desc: Is shipping included to cost
 *
 * itemCost - Type: numeric. Desc: Original cost
 *
 * itemsQuantity - Type: numeric. Desc: Total number of variants
 *
 * marketplace - Type: string. Desc: RTS/POD
 *
 * modalystOrderId - Type: string. Desc: Unique id from modalyst site
 *
 * modalystOrderNumber - Type: numeric. Desc: number that is displayed for user in interface
 *
 * modalystProductId - Type: string. Desc: modalyst_product_id
 *
 * modalystServiceFee - Type: numeric. Desc: Modalyst_service_fee (retailer)
 *
 * modalystVariantIds - Type: string. Desc: List of variant ids
 *
 * bi_token - Type: guid. Desc: wix msid
 *
 * numItems - Type: numeric. Desc: Distinct variants
 *
 * numProducts - Type: numeric. Desc: Distinct products
 *
 * origin - Type: string. Desc: Import list/synced products list/product page
 *
 * productName - Type: string. Desc: product_name
 *
 * retailerProductId - Type: string. Desc: retailerProductId
 *
 * retailerStorePlatform - Type: string. Desc: retailer store platform
 *
 * retailerVariantIds - Type: string. Desc: List of retailer variants id
 *
 * shippingRate - Type: numeric. Desc: Shipping cost
 *
 * storeUrl - Type: string. Desc: site's url. Null for Wix users
 *
 * subscriptionPlanId - Type: string. Desc: package id in modalyst definition
 *
 * supplierId - Type: string. Desc: supplier Id
 *
 * supplierProductId - Type: string. Desc: supplier ProductI d
 *
 * totalAmount - Type: numeric. Desc: Retail order price (total price)
 *
 * variantsCount - Type: numeric. Desc: Number of variants in the order / sample order
 * @param {placeAnOrderClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var placeAnOrderClicked = function (params) {
    return { evid: 12, src: 145, endpoint: 'modalyst', params: params };
};
/**
* @typedef {Object} disconnectStoreClickedParams
* @property {string} accountId - modalyst account id
* @property {string} businessId - modalyst business id
* @property {string} correlationId - correlation_id
* @property {string} instanceId - instanceId
* @property {boolean} isDebug - null
* @property {boolean} isPremium - is modalyst premium
* @property {GUID} msid - msid
* @property {string} retailerStorePlatform - retailer store platform
* @property {string} storeName - the name of the store the user wants to disconnect
* @property {string} storeUrl - site's url. Null for Wix users
* @property {string} subscriptionPlanId - package id in modalyst definition
* @property {GUID} targetStoreId - the id of the store the user wants to disconnect
* @property {string} uuid - uuid
**/
/**
 * Name: Modalyst Multi-stores: Disconnect store Clicked. Evid: 26.
 * Event description: Disconnect store Clicked.

 * accountId - Type: string. Desc: modalyst account id
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * correlationId - Type: string. Desc: correlation_id
 *
 * instanceId - Type: string. Desc: instanceId
 *
 * isDebug - Type: bool.
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * msid - Type: guid. Desc: msid
 *
 * retailerStorePlatform - Type: string. Desc: retailer store platform
 *
 * storeName - Type: string. Desc: the name of the store the user wants to disconnect
 *
 * storeUrl - Type: string. Desc: site's url. Null for Wix users
 *
 * subscriptionPlanId - Type: string. Desc: package id in modalyst definition
 *
 * targetStoreId - Type: guid. Desc: the id of the store the user wants to disconnect
 *
 * uuid - Type: string. Desc: uuid
 * @param {disconnectStoreClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var disconnectStoreClicked = function (params) {
    return { evid: 26, src: 145, endpoint: 'modalyst', params: params };
};
/**
* @typedef {Object} disconnectStoreConfirmModalConfirmedParams
* @property {string} accountId - account_id
* @property {string} businessId - modalyst business id
* @property {string} correlationId - correlation_id
* @property {string} instanceId - instanceId
* @property {boolean} isDebug - is debug mode
* @property {boolean} isPremium - is modalyst premium
* @property {GUID} msid - msid
* @property {string} retailerStorePlatform - retailer store platform
* @property {string} storeName - the name of the store the user wants to disconnect
* @property {string} storeUrl - site's url. Null for Wix users
* @property {string} subscriptionPlanId - package id in modalyst definition
* @property {GUID} targetStoreId - the id of the store the user wants to disconnect
* @property {string} uuid - uuid
**/
/**
 * Name: Modalyst Multi-stores: Disconnect store modal -> disconnect store button clicked. Evid: 33.
 * Event description: Disconnect store modal -> user clicked disconnect store button.

 * accountId - Type: string. Desc: account_id
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * correlationId - Type: string. Desc: correlation_id
 *
 * instanceId - Type: string. Desc: instanceId
 *
 * isDebug - Type: bool. Desc: is debug mode
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * msid - Type: guid. Desc: msid
 *
 * retailerStorePlatform - Type: string. Desc: retailer store platform
 *
 * storeName - Type: string. Desc: the name of the store the user wants to disconnect
 *
 * storeUrl - Type: string. Desc: site's url. Null for Wix users
 *
 * subscriptionPlanId - Type: string. Desc: package id in modalyst definition
 *
 * targetStoreId - Type: guid. Desc: the id of the store the user wants to disconnect
 *
 * uuid - Type: string. Desc: uuid
 * @param {disconnectStoreConfirmModalConfirmedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var disconnectStoreConfirmModalConfirmed = function (params) {
    return { evid: 33, src: 145, endpoint: 'modalyst', params: params };
};
/**
* @typedef {Object} connectStoreModalStoreNameSubmittedParams
* @property {string} accountId - modalyst account id
* @property {string} businessId - modalyst business id
* @property {string} correlationId - correlation_id
* @property {string} instanceId - instanceId
* @property {boolean} isDebug - is debug mode
* @property {boolean} isPremium - is modalyst premium
* @property {GUID} msid - msid
* @property {string} retailerStorePlatform - retailer store platform
* @property {string} storeName - name of the new store the use tries to connect/create
* @property {string} storeUrl - site's url. Null for Wix users
* @property {string} subscriptionPlanId - package id in modalyst definition
* @property {string} uuid - uuid
**/
/**
 * Name: Modalyst Multi-stores: Connect Shopify store modal ->store name submitted. Evid: 19.
 * Event description: Connect Shopify store modal -> connect store.

 * accountId - Type: string. Desc: modalyst account id
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * correlationId - Type: string. Desc: correlation_id
 *
 * instanceId - Type: string. Desc: instanceId
 *
 * isDebug - Type: bool. Desc: is debug mode
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * msid - Type: guid. Desc: msid
 *
 * retailerStorePlatform - Type: string. Desc: retailer store platform
 *
 * storeName - Type: string. Desc: name of the new store the use tries to connect/create
 *
 * storeUrl - Type: string. Desc: site's url. Null for Wix users
 *
 * subscriptionPlanId - Type: string. Desc: package id in modalyst definition
 *
 * uuid - Type: string. Desc: uuid
 * @param {connectStoreModalStoreNameSubmittedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var connectStoreModalStoreNameSubmitted = function (params) {
    return { evid: 19, src: 145, endpoint: 'modalyst', params: params };
};
/**
* @typedef {Object} deleteStoreConfirmModalConfirmedParams
* @property {string} accountId - null
* @property {string} businessId - modalyst business id
* @property {string} correlationId - correlation_id
* @property {string} instanceId - instanceId
* @property {boolean} isDebug - is debug mode
* @property {boolean} isPremium - is modalyst premium
* @property {GUID} msid - msid
* @property {string} retailerStorePlatform - retailer store platform
* @property {string} storeName - the name of the store the user wants to delete
* @property {string} storeUrl - site's url. Null for Wix users
* @property {string} subscriptionPlanId - package id in modalyst definition
* @property {GUID} targetStoreId - the id of the store the user wants to delete
* @property {string} uuid - uuid
**/
/**
 * Name: Modalyst Multi-stores: Delete store Modal -> Delete Stores Clicked. Evid: 25.
 * Event description: Delete store Modal -> Delete Stores Clicked.

 * accountId - Type: string.
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * correlationId - Type: string. Desc: correlation_id
 *
 * instanceId - Type: string. Desc: instanceId
 *
 * isDebug - Type: bool. Desc: is debug mode
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * msid - Type: guid. Desc: msid
 *
 * retailerStorePlatform - Type: string. Desc: retailer store platform
 *
 * storeName - Type: string. Desc: the name of the store the user wants to delete
 *
 * storeUrl - Type: string. Desc: site's url. Null for Wix users
 *
 * subscriptionPlanId - Type: string. Desc: package id in modalyst definition
 *
 * targetStoreId - Type: guid. Desc: the id of the store the user wants to delete
 *
 * uuid - Type: string. Desc: uuid
 * @param {deleteStoreConfirmModalConfirmedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var deleteStoreConfirmModalConfirmed = function (params) {
    return { evid: 25, src: 145, endpoint: 'modalyst', params: params };
};
/**
* @typedef {Object} syncingProcessFinishedParams
* @property {string} accountId - modalyst account id
* @property {string} businessId - modalyst business id
* @property {string} errorDescription - errorDescription
* @property {string} errorType - errorType
* @property {string} externalRetailerProductId - External_retailer_product_id (wix product id)
* @property {string} instanceId - instanceId
* @property {boolean} isDebug - is debug mode
* @property {boolean} isPremium - is modalyst premium
* @property {boolean} isSuccess - isSuccess
* @property {string} marketplace - pod/rts
* @property {string} modalystProductId - modalyst_product_id
* @property {string} retailerProductId - retailer_product_id
* @property {string} retailerStorePlatform - retailer store platform
* @property {string} storeUrl - site's url. Null for Wix users
* @property {string} subscriptionPlanId - package id in modalyst definition
* @property {string} supplierId - supplier_id
* @property {string} supplierProductId - supplier_product_id
**/
/**
 * Name: Syncing process finished. Evid: 1006.
 * Event description: Syncing process finished.

 * accountId - Type: string. Desc: modalyst account id
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * errorDescription - Type: string. Desc: errorDescription
 *
 * errorType - Type: string. Desc: errorType
 *
 * externalRetailerProductId - Type: string. Desc: External_retailer_product_id (wix product id)
 *
 * instanceId - Type: string. Desc: instanceId
 *
 * isDebug - Type: bool. Desc: is debug mode
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * isSuccess - Type: bool. Desc: isSuccess
 *
 * marketplace - Type: string. Desc: pod/rts
 *
 * modalystProductId - Type: string. Desc: modalyst_product_id
 *
 * retailerProductId - Type: string. Desc: retailer_product_id
 *
 * retailerStorePlatform - Type: string. Desc: retailer store platform
 *
 * storeUrl - Type: string. Desc: site's url. Null for Wix users
 *
 * subscriptionPlanId - Type: string. Desc: package id in modalyst definition
 *
 * supplierId - Type: string. Desc: supplier_id
 *
 * supplierProductId - Type: string. Desc: supplier_product_id
 * @param {syncingProcessFinishedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var syncingProcessFinished = function (params) {
    return { evid: 1006, src: 145, endpoint: 'modalyst', params: params };
};
/**
* @typedef {Object} upgradeStoreClickedParams
* @property {string} accountId - modalyst account id
* @property {string} businessId - modalyst business id
* @property {string} correlationId - correlation_id
* @property {string} instanceId - instanceId
* @property {boolean} isDebug - is debug mode
* @property {boolean} isPremium - is modalyst premium
* @property {GUID} msid - msid
* @property {number} numProductsLeft - number of product left in the user plan
* @property {string} origin - store card/ side navigation
* @property {string} retailerStorePlatform - retailer store platform
* @property {string} storeName - name of store the user want to upgrade
* @property {string} storeUrl - site's url. Null for Wix users
* @property {string} subscriptionPlanId - package id in modalyst definition
* @property {GUID} targetStoreId - id of store the user want to upgrade
* @property {string} uuid - uuid
**/
/**
 * Name: Modalyst Multi-stores: Upgrade Your Store Clicked. Evid: 32.
 * Event description: when users clicks "upgrade your store button".

 * accountId - Type: string. Desc: modalyst account id
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * correlationId - Type: string. Desc: correlation_id
 *
 * instanceId - Type: string. Desc: instanceId
 *
 * isDebug - Type: bool. Desc: is debug mode
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * msid - Type: guid. Desc: msid
 *
 * numProductsLeft - Type: numeric. Desc: number of product left in the user plan
 *
 * origin - Type: string. Desc: store card/ side navigation
 *
 * retailerStorePlatform - Type: string. Desc: retailer store platform
 *
 * storeName - Type: string. Desc: name of store the user want to upgrade
 *
 * storeUrl - Type: string. Desc: site's url. Null for Wix users
 *
 * subscriptionPlanId - Type: string. Desc: package id in modalyst definition
 *
 * targetStoreId - Type: guid. Desc: id of store the user want to upgrade
 *
 * uuid - Type: string. Desc: uuid
 * @param {upgradeStoreClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var upgradeStoreClicked = function (params) {
    return { evid: 32, src: 145, endpoint: 'modalyst', params: params };
};
/**
* @typedef {Object} modalystPremiumUpgradedParams
* @property {string} accountId - modalyst account id
* @property {string} businessId - modalyst business id
* @property {string} cycleName - Premium cycle
* @property {string} instanceId - instanceId
* @property {boolean} isDebug - is debug mode
* @property {boolean} isPremium - is modalyst premium
* @property {string} premiumPlanId - Package name
* @property {string} prevSubscriptionId - Previous subscription id (null if it first)
* @property {string} retailerStorePlatform - retailer store platform
* @property {string} source - upgrade/bundle
* @property {string} subscriptionId - Subscription id
* @property {string} subscriptionPlanId - package id in modalyst definition
* @property {string} url - site's url. Null for Wix users
**/
/**
 * Name: Modalyst Premium Upgraded. Evid: 1012.
 * Event description: Modalyst Premium Upgraded.

 * accountId - Type: string. Desc: modalyst account id
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * cycleName - Type: string. Desc: Premium cycle
 *
 * instanceId - Type: string. Desc: instanceId
 *
 * isDebug - Type: bool. Desc: is debug mode
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * premiumPlanId - Type: string. Desc: Package name
 *
 * prevSubscriptionId - Type: string. Desc: Previous subscription id (null if it first)
 *
 * retailerStorePlatform - Type: string. Desc: retailer store platform
 *
 * source - Type: string. Desc: upgrade/bundle
 *
 * subscriptionId - Type: string. Desc: Subscription id
 *
 * subscriptionPlanId - Type: string. Desc: package id in modalyst definition
 *
 * url - Type: string. Desc: site's url. Null for Wix users
 * @param {modalystPremiumUpgradedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var modalystPremiumUpgraded = function (params) {
    return { evid: 1012, src: 145, endpoint: 'modalyst', params: params };
};
/**
* @typedef {Object} disconnectStoreConfirmModalShownParams
* @property {string} accountId - null
* @property {string} businessId - modalyst business id
* @property {string} correlationId - correlation_id
* @property {string} instanceId - instanceId
* @property {boolean} isDebug - is debug mode
* @property {boolean} isPremium - is modalyst premium
* @property {GUID} msid - msid
* @property {string} retailerStorePlatform - retailer store platform
* @property {string} storeName - the name of the store the user wants to disconnect
* @property {string} storeUrl - site's url. Null for Wix users
* @property {string} subscriptionPlanId - package id in modalyst definition
* @property {GUID} targetStoreId - the id of the store the user wants to disconnect
* @property {string} uuid - null
**/
/**
 * Name: Modalyst Multi-stores: Disconnect store modal -> shown. Evid: 27.
 * Event description: Disconnect store modal -> loaded.

 * accountId - Type: string.
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * correlationId - Type: string. Desc: correlation_id
 *
 * instanceId - Type: string. Desc: instanceId
 *
 * isDebug - Type: bool. Desc: is debug mode
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * msid - Type: guid. Desc: msid
 *
 * retailerStorePlatform - Type: string. Desc: retailer store platform
 *
 * storeName - Type: string. Desc: the name of the store the user wants to disconnect
 *
 * storeUrl - Type: string. Desc: site's url. Null for Wix users
 *
 * subscriptionPlanId - Type: string. Desc: package id in modalyst definition
 *
 * targetStoreId - Type: guid. Desc: the id of the store the user wants to disconnect
 *
 * uuid - Type: string.
 * @param {disconnectStoreConfirmModalShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var disconnectStoreConfirmModalShown = function (params) {
    return { evid: 27, src: 145, endpoint: 'modalyst', params: params };
};
/**
* @typedef {Object} alibabaAliexpressSettingsClickedParams
* @property {string} accountId - modalyst account id
* @property {string} businessId - modalyst business id
* @property {string} instanceId - instanceId
* @property {boolean} isDebug - is debug mode
* @property {boolean} isPremium - is modalyst premium
* @property {GUID} msid - msid
* @property {string} origin - main panel/ top actions
* @property {string} retailerStorePlatform - retailer store platform
* @property {string} storeUrl - site's url. Null for Wix users
* @property {string} subscriptionPlanId - package id in modalyst definition
* @property {string} uuid - uuid
**/
/**
 * Name: Modalyst Multi-stores: Alibaba aliexpress settings clicked. Evid: 28.
 * Event description: when user clicks on Alibaba aliexpress settings.

 * accountId - Type: string. Desc: modalyst account id
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * instanceId - Type: string. Desc: instanceId
 *
 * isDebug - Type: bool. Desc: is debug mode
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: main panel/ top actions
 *
 * retailerStorePlatform - Type: string. Desc: retailer store platform
 *
 * storeUrl - Type: string. Desc: site's url. Null for Wix users
 *
 * subscriptionPlanId - Type: string. Desc: package id in modalyst definition
 *
 * uuid - Type: string. Desc: uuid
 * @param {alibabaAliexpressSettingsClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var alibabaAliexpressSettingsClicked = function (params) {
    return { evid: 28, src: 145, endpoint: 'modalyst', params: params };
};
/**
* @typedef {Object} receiveOrderParams
* @property {string} accountId - modalyst account id
* @property {string} businessId - modalyst business id
* @property {string} instanceId - instanceId
* @property {boolean} isDebug - is debug mode
* @property {boolean} isManual - Is order placed manually by retailer
* @property {boolean} isPremium - is modalyst premium
* @property {boolean} isShippingInCost - Is shipping included to cost
* @property {number} itemCost - Original cost
* @property {number} itemsQuantity - Total variants
* @property {string} marketplace - RTS/POD
* @property {string} modalystOrderId - Unic id from modalyst site
* @property {number} modalystOrderNumber - number that is displayed for user in interface
* @property {string} modalystProductId - modalyst_product_id
* @property {string} modalystProductIds - JSON with modalyst_product_ids in order
* @property {number} modalystServiceFee - Modalyst_service_fee (retailer)
* @property {number} numItems - Distinct variants
* @property {number} numProducts - Distinct products
* @property {string} retailerOrderId - Retailer_order_id (wix)
* @property {string} retailerProductIds - JSON with list of retailer products ids in order
* @property {string} retailerStorePlatform - retailer store platform
* @property {number} shippingRate - Shipping cost
* @property {string} storeUrl - site's url. Null for Wix users
* @property {string} subscriptionPlanId - package id in modalyst definition
* @property {string} supplierId - supplier_id
* @property {string} supplierProductId - supplier_product_id
* @property {string} supplierProductIds - JSON with Supplier product ids in order
* @property {number} totalAmount - Retail order price (total price)
**/
/**
 * Name: Receive order. Evid: 1008.
 * Event description: send it to each each retailer_product_id(for POD) and supplier - for RTS.

 * accountId - Type: string. Desc: modalyst account id
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * instanceId - Type: string. Desc: instanceId
 *
 * isDebug - Type: bool. Desc: is debug mode
 *
 * isManual - Type: bool. Desc: Is order placed manually by retailer
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * isShippingInCost - Type: bool. Desc: Is shipping included to cost
 *
 * itemCost - Type: numeric. Desc: Original cost
 *
 * itemsQuantity - Type: numeric. Desc: Total variants
 *
 * marketplace - Type: string. Desc: RTS/POD
 *
 * modalystOrderId - Type: string. Desc: Unic id from modalyst site
 *
 * modalystOrderNumber - Type: numeric. Desc: number that is displayed for user in interface
 *
 * modalystProductId - Type: string. Desc: modalyst_product_id
 *
 * modalystProductIds - Type: string. Desc: JSON with modalyst_product_ids in order
 *
 * modalystServiceFee - Type: numeric. Desc: Modalyst_service_fee (retailer)
 *
 * numItems - Type: numeric. Desc: Distinct variants
 *
 * numProducts - Type: numeric. Desc: Distinct products
 *
 * retailerOrderId - Type: string. Desc: Retailer_order_id (wix)
 *
 * retailerProductIds - Type: string. Desc: JSON with list of retailer products ids in order
 *
 * retailerStorePlatform - Type: string. Desc: retailer store platform
 *
 * shippingRate - Type: numeric. Desc: Shipping cost
 *
 * storeUrl - Type: string. Desc: site's url. Null for Wix users
 *
 * subscriptionPlanId - Type: string. Desc: package id in modalyst definition
 *
 * supplierId - Type: string. Desc: supplier_id
 *
 * supplierProductId - Type: string. Desc: supplier_product_id
 *
 * supplierProductIds - Type: string. Desc: JSON with Supplier product ids in order
 *
 * totalAmount - Type: numeric. Desc: Retail order price (total price)
 * @param {receiveOrderParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var receiveOrder = function (params) {
    return { evid: 1008, src: 145, endpoint: 'modalyst', params: params };
};
/**
* @typedef {Object} storeCard3dotsClickedParams
* @property {string} accountId - modalyst account id
* @property {string} businessId - modalyst business id
* @property {string} correlationId - correlation_id
* @property {string} instanceId - instanceId
* @property {boolean} isDebug - is debug mode
* @property {boolean} isPremium - is modalyst premium
* @property {GUID} msid - msid
* @property {string} retailerStorePlatform - retailer store platform
* @property {string} storeName - the name of the store the user wants navigate to
* @property {string} storeUrl - site's url. Null for Wix users
* @property {string} subscriptionPlanId - package id in modalyst definition
* @property {GUID} targetStoreId - the id of the store the user wants navigate to
* @property {string} uuid - uuid
**/
/**
 * Name: Modalyst Multi-stores: Store Card-> 3Dots Clicked. Evid: 22.
 * Event description: Store Card-> 3Dots Clicked.

 * accountId - Type: string. Desc: modalyst account id
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * correlationId - Type: string. Desc: correlation_id
 *
 * instanceId - Type: string. Desc: instanceId
 *
 * isDebug - Type: bool. Desc: is debug mode
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * msid - Type: guid. Desc: msid
 *
 * retailerStorePlatform - Type: string. Desc: retailer store platform
 *
 * storeName - Type: string. Desc: the name of the store the user wants navigate to
 *
 * storeUrl - Type: string. Desc: site's url. Null for Wix users
 *
 * subscriptionPlanId - Type: string. Desc: package id in modalyst definition
 *
 * targetStoreId - Type: guid. Desc: the id of the store the user wants navigate to
 *
 * uuid - Type: string. Desc: uuid
 * @param {storeCard3dotsClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var storeCard3dotsClicked = function (params) {
    return { evid: 22, src: 145, endpoint: 'modalyst', params: params };
};
/**
* @typedef {Object} connectStoreModalShownParams
* @property {string} accountId - modalyst account id
* @property {string} businessId - modalyst business id
* @property {string} correlationId - correlation_id
* @property {string} instanceId - instanceId
* @property {boolean} isDebug - is debug mode
* @property {boolean} isPremium - is modalyst premium
* @property {GUID} msid - msid
* @property {string} retailerStorePlatform - retailer store platform
* @property {string} storeName - name of the store users try to connect
* @property {string} storeUrl - site's url. Null for Wix users
* @property {string} subscriptionPlanId - package id in modalyst definition
* @property {GUID} targetStoreId - id of the store users try to connect
* @property {string} uuid - uuid
**/
/**
 * Name: Modalyst Multi-stores: Store Connection modal -> shown. Evid: 30.
 * Event description: when store connection modal is shown to user.

 * accountId - Type: string. Desc: modalyst account id
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * correlationId - Type: string. Desc: correlation_id
 *
 * instanceId - Type: string. Desc: instanceId
 *
 * isDebug - Type: bool. Desc: is debug mode
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * msid - Type: guid. Desc: msid
 *
 * retailerStorePlatform - Type: string. Desc: retailer store platform
 *
 * storeName - Type: string. Desc: name of the store users try to connect
 *
 * storeUrl - Type: string. Desc: site's url. Null for Wix users
 *
 * subscriptionPlanId - Type: string. Desc: package id in modalyst definition
 *
 * targetStoreId - Type: guid. Desc: id of the store users try to connect
 *
 * uuid - Type: string. Desc: uuid
 * @param {connectStoreModalShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var connectStoreModalShown = function (params) {
    return { evid: 30, src: 145, endpoint: 'modalyst', params: params };
};
/**
* @typedef {Object} productCsvExportedParams
* @property {string} accountId - modalyst account id
* @property {string} businessId - modalyst business id
* @property {string} correlationId - correlation_id
* @property {number} productCount - Number of products
* @property {string} currency - currency
* @property {number} duration - exporting duration
* @property {string} errorDescription - Error description
* @property {string} instanceId - instanceId
* @property {boolean} isBulk - is bulk action
* @property {boolean} isDebug - is debug mode
* @property {boolean} isPremium - is modalyst premium
* @property {boolean} isSuccess - is_success
* @property {string} marketplace - RTS/POD
* @property {GUID} biToken - wix msid
* @property {string} origin - Import list/synced products list
* @property {string} retailerStorePlatform - retailer store platform
* @property {string} subscriptionPlanId - package id in modalyst definition
* @property {string} type - csv/shopify/bigcommerce
* @property {string} url - site's url. Null for Wix users
* @property {number} variantsCount - variantsCount
**/
/**
 * Name: Product CSV Exported. Evid: 1013.
 * Event description: product's csv exported.

 * accountId - Type: string. Desc: modalyst account id
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * correlationId - Type: string. Desc: correlation_id
 *
 * productCount - Type: numeric. Desc: Number of products
 *
 * currency - Type: string. Desc: currency
 *
 * duration - Type: numeric. Desc: exporting duration
 *
 * errorDescription - Type: string. Desc: Error description
 *
 * instanceId - Type: string. Desc: instanceId
 *
 * isBulk - Type: bool. Desc: is bulk action
 *
 * isDebug - Type: bool. Desc: is debug mode
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * isSuccess - Type: bool. Desc: is_success
 *
 * marketplace - Type: string. Desc: RTS/POD
 *
 * biToken - Type: guid. Desc: wix msid
 *
 * origin - Type: string. Desc: Import list/synced products list
 *
 * retailerStorePlatform - Type: string. Desc: retailer store platform
 *
 * subscriptionPlanId - Type: string. Desc: package id in modalyst definition
 *
 * type - Type: string. Desc: csv/shopify/bigcommerce
 *
 * url - Type: string. Desc: site's url. Null for Wix users
 *
 * variantsCount - Type: numeric. Desc: variantsCount
 * @param {productCsvExportedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var productCsvExported = function (params) {
    return { evid: 1013, src: 145, endpoint: 'modalyst', params: params };
};
/**
* @typedef {Object} productRemovedFromImportListParams
* @property {string} accountId - modalyst account id
* @property {string} businessId - modalyst business id
* @property {string} correlationId - correlation_id
* @property {string} errorDescription - Error description
* @property {string} instanceId - instanceId
* @property {boolean} isDebug - is debug mode
* @property {boolean} isPremium - is modalyst premium
* @property {boolean} isSuccess - is_success
* @property {string} marketplace - RTS/POD
* @property {string} modalystProductId - Modalyst_product_id
* @property {string} modalystVariantIds - List of variant ids
* @property {GUID} bi_token - wix msid
* @property {string} retailerProductId - retailer_product_id
* @property {string} retailerStorePlatform - null
* @property {string} retailerVariantIds - List of variant ids
* @property {string} subscriptionPlanId - package id in modalyst definition
* @property {string} supplierId - supplier Id
* @property {string} url - site's url. Null for Wix users
**/
/**
 * Name: Product removed from Import list. Evid: 1014.
 * Event description: Product removed from Import list.

 * accountId - Type: string. Desc: modalyst account id
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * correlationId - Type: string. Desc: correlation_id
 *
 * errorDescription - Type: string. Desc: Error description
 *
 * instanceId - Type: string. Desc: instanceId
 *
 * isDebug - Type: bool. Desc: is debug mode
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * isSuccess - Type: bool. Desc: is_success
 *
 * marketplace - Type: string. Desc: RTS/POD
 *
 * modalystProductId - Type: string. Desc: Modalyst_product_id
 *
 * modalystVariantIds - Type: string. Desc: List of variant ids
 *
 * bi_token - Type: guid. Desc: wix msid
 *
 * retailerProductId - Type: string. Desc: retailer_product_id
 *
 * retailerStorePlatform - Type: string.
 *
 * retailerVariantIds - Type: string. Desc: List of variant ids
 *
 * subscriptionPlanId - Type: string. Desc: package id in modalyst definition
 *
 * supplierId - Type: string. Desc: supplier Id
 *
 * url - Type: string. Desc: site's url. Null for Wix users
 * @param {productRemovedFromImportListParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var productRemovedFromImportList = function (params) {
    return { evid: 1014, src: 145, endpoint: 'modalyst', params: params };
};
/**
* @typedef {Object} addNewStoreModalNextClickedParams
* @property {string} accountId - modalyst account id
* @property {string} action - null
* @property {string} businessId - modalyst business id
* @property {string} correlationId - correlation_id
* @property {string} country - country
* @property {string} instanceId - instanceId
* @property {boolean} isDebug - null
* @property {boolean} isPremium - is modalyst premium
* @property {GUID} msid - msid
* @property {string} origin - sign up/retailer
* @property {string} retailerStorePlatform - retailer store platform
* @property {string} storeName - storeName
* @property {string} storeUrl - site's url. Null for Wix users
* @property {string} subscriptionPlanId - package id in modalyst definition
* @property {string} uuid - uuid
**/
/**
 * Name: Modalyst Multi-stores: New Store Modal -> clicked next. Evid: 18.
 * Event description: Stores Dropdown Clicked.

 * accountId - Type: string. Desc: modalyst account id
 *
 * action - Type: string.
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * correlationId - Type: string. Desc: correlation_id
 *
 * country - Type: string. Desc: country
 *
 * instanceId - Type: string. Desc: instanceId
 *
 * isDebug - Type: bool.
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: sign up/retailer
 *
 * retailerStorePlatform - Type: string. Desc: retailer store platform
 *
 * storeName - Type: string. Desc: storeName
 *
 * storeUrl - Type: string. Desc: site's url. Null for Wix users
 *
 * subscriptionPlanId - Type: string. Desc: package id in modalyst definition
 *
 * uuid - Type: string. Desc: uuid
 * @param {addNewStoreModalNextClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addNewStoreModalNextClicked = function (params) {
    return { evid: 18, src: 145, endpoint: 'modalyst', params: params };
};
/**
* @typedef {Object} designProductClickedParams
* @property {string} accountId - modalyst account id
* @property {string} appliedFilters - Applied filters when product was selected
* @property {string} appliedSort - Applied sorting when product was clicked
* @property {string} businessId - modalyst business id
* @property {string} correlationId - correlation_id
* @property {string} instanceId - instanceId
* @property {boolean} isDebug - is debug mode
* @property {boolean} isPremium - is modalyst premium
* @property {string} marketplace - RTS/POD
* @property {string} modalystProductId - modalyst_product_id
* @property {string} origin - dashboard / sync list
* @property {number} position - Product position in page
* @property {string} productName - productName
* @property {string} retailerProductId - retailerProductId
* @property {string} retailerStorePlatform - retailer store platform
* @property {string} storeUrl - site's url. Null for Wix users
* @property {string} subscriptionPlanId - package id in modalyst definition
* @property {string} supplierProductId - supplier_product_id
**/
/**
 * Name: Design Product Clicked. Evid: 4.
 * Event description: When user clicks on design product.

 * accountId - Type: string. Desc: modalyst account id
 *
 * appliedFilters - Type: string. Desc: Applied filters when product was selected
 *
 * appliedSort - Type: string. Desc: Applied sorting when product was clicked
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * correlationId - Type: string. Desc: correlation_id
 *
 * instanceId - Type: string. Desc: instanceId
 *
 * isDebug - Type: bool. Desc: is debug mode
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * marketplace - Type: string. Desc: RTS/POD
 *
 * modalystProductId - Type: string. Desc: modalyst_product_id
 *
 * origin - Type: string. Desc: dashboard / sync list
 *
 * position - Type: numeric. Desc: Product position in page
 *
 * productName - Type: string. Desc: productName
 *
 * retailerProductId - Type: string. Desc: retailerProductId
 *
 * retailerStorePlatform - Type: string. Desc: retailer store platform
 *
 * storeUrl - Type: string. Desc: site's url. Null for Wix users
 *
 * subscriptionPlanId - Type: string. Desc: package id in modalyst definition
 *
 * supplierProductId - Type: string. Desc: supplier_product_id
 * @param {designProductClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var designProductClicked = function (params) {
    return { evid: 4, src: 145, endpoint: 'modalyst', params: params };
};
/**
* @typedef {Object} storeDisconnectedParams
* @property {string} accountId - modalyst account id
* @property {string} businessId - modalyst business id
* @property {string} instanceId - instanceId
* @property {boolean} isDebug - is debug mode
* @property {boolean} isPremium - is modalyst premium
* @property {string} retailerStorePlatform - retailer store platform
* @property {string} subscriptionPlanId - package id in modalyst definition
**/
/**
 * Name: Store Disconnected. Evid: 1011.
 * Event description: Store Disconnected.

 * accountId - Type: string. Desc: modalyst account id
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * instanceId - Type: string. Desc: instanceId
 *
 * isDebug - Type: bool. Desc: is debug mode
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * retailerStorePlatform - Type: string. Desc: retailer store platform
 *
 * subscriptionPlanId - Type: string. Desc: package id in modalyst definition
 * @param {storeDisconnectedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var storeDisconnected = function (params) {
    return { evid: 1011, src: 145, endpoint: 'modalyst', params: params };
};
/**
* @typedef {Object} productEditedParams
* @property {string} accountId - modalyst account id
* @property {string} businessId - modalyst business id
* @property {string} correlationId - correlation_id
* @property {string} currency - currency
* @property {string} instanceId - instanceId
* @property {boolean} isDebug - is debug mode
* @property {boolean} isDynamicPrice - is_dynamic_price
* @property {boolean} isPremium - is modalyst premium
* @property {boolean} isShippingInCost - Is shipping included to cost
* @property {string} itemsCost - JSON with variants origin prices
* @property {string} marketplace - RTS/POD
* @property {string} modalystProductId - modalyst_product_id
* @property {string} modalystVariantIds - Null if user change smth in product level/variant id if change variant setting
* @property {GUID} bi_token - wix msid
* @property {string} newValue - New value (for the variant change add variant_id:new value)
* @property {string} oldValue - Old value
* @property {string} origin - PODeditor/draft list/product page/import list
* @property {string} retailerPrices - JSON with retailer prices
* @property {string} retailerProductId - retailerProductId
* @property {string} retailerStorePlatform - retailer store platform
* @property {string} retailerVariantIds - Null if user change smth in product level/variant id if change variant setting
* @property {string} settingField - Which change made by the user: product description/product name/variant turned off/…
* @property {string} settingTab - In which tab user make change
* @property {number} shippingRate - Shipping cost
* @property {string} storeUrl - site's url. Null for Wix users
* @property {string} subscriptionPlanId - package id in modalyst definition
* @property {string} supplierId - supplier Id
* @property {string} supplierProductId - Supplier product id (sometimes can be null)
* @property {number} variantsCount - Number of variants
**/
/**
 * Name: Product Edited. Evid: 13.
 * Event description: When user edited a product.

 * accountId - Type: string. Desc: modalyst account id
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * correlationId - Type: string. Desc: correlation_id
 *
 * currency - Type: string. Desc: currency
 *
 * instanceId - Type: string. Desc: instanceId
 *
 * isDebug - Type: bool. Desc: is debug mode
 *
 * isDynamicPrice - Type: bool. Desc: is_dynamic_price
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * isShippingInCost - Type: bool. Desc: Is shipping included to cost
 *
 * itemsCost - Type: string. Desc: JSON with variants origin prices
 *
 * marketplace - Type: string. Desc: RTS/POD
 *
 * modalystProductId - Type: string. Desc: modalyst_product_id
 *
 * modalystVariantIds - Type: string. Desc: Null if user change smth in product level/variant id if change variant setting
 *
 * bi_token - Type: guid. Desc: wix msid
 *
 * newValue - Type: string. Desc: New value (for the variant change add variant_id:new value)
 *
 * oldValue - Type: string. Desc: Old value
 *
 * origin - Type: string. Desc: PODeditor/draft list/product page/import list
 *
 * retailerPrices - Type: string. Desc: JSON with retailer prices
 *
 * retailerProductId - Type: string. Desc: retailerProductId
 *
 * retailerStorePlatform - Type: string. Desc: retailer store platform
 *
 * retailerVariantIds - Type: string. Desc: Null if user change smth in product level/variant id if change variant setting
 *
 * settingField - Type: string. Desc: Which change made by the user: product description/product name/variant turned off/…
 *
 * settingTab - Type: string. Desc: In which tab user make change
 *
 * shippingRate - Type: numeric. Desc: Shipping cost
 *
 * storeUrl - Type: string. Desc: site's url. Null for Wix users
 *
 * subscriptionPlanId - Type: string. Desc: package id in modalyst definition
 *
 * supplierId - Type: string. Desc: supplier Id
 *
 * supplierProductId - Type: string. Desc: Supplier product id (sometimes can be null)
 *
 * variantsCount - Type: numeric. Desc: Number of variants
 * @param {productEditedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var productEdited = function (params) {
    return { evid: 13, src: 145, endpoint: 'modalyst', params: params };
};
/**
* @typedef {Object} addProductToSyncListClickedParams
* @property {string} accountId - modalyst account id
* @property {string} businessId - modalyst business id
* @property {string} correlationId - id to connect between client and server event
* @property {string} currency - currency
* @property {string} hiddenVariantIds - string with list of variants
* @property {number} hiddenVariantsCount - number of variants that were not synced
* @property {number} imagesNum - Num of images
* @property {string} instanceId - instanceId
* @property {boolean} isBulk - is bulk action
* @property {boolean} isDebug - is debug mode
* @property {boolean} isDynamicPrice - Is dynamic price
* @property {boolean} isPremium - is modalyst premium
* @property {boolean} isShippingInCost - Is shipping included in cost
* @property {string} itemsCost - JSON with variants origin prices
* @property {string} mainImageUrl - main_image_url
* @property {string} marketplace - RTS/POD
* @property {string} modalystProductId - modalyst_product_id
* @property {string} modalystVariantIds - List of variant ids
* @property {GUID} bi_token - wix msid
* @property {string} origin - POD editor/draft list/product page
* @property {string} productDescription - Product description
* @property {string} productName - productName
* @property {string} retailerPrices - JSON with retailer prices
* @property {string} retailerProductId - retailerProductId. Null if bulk action
* @property {string} retailerStorePlatform - retailer store platform
* @property {string} retailerVariantIds - List of retailer variants id
* @property {string} storeUrl - site's url. Null for Wix users
* @property {string} subscriptionPlanId - package id in modalyst definition
* @property {number} variantsCount - number of variants
**/
/**
 * Name: Add Product To Sync List Clicked. Evid: 7.
 * Event description: When user clicked to add product to sync list.

 * accountId - Type: string. Desc: modalyst account id
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * correlationId - Type: string. Desc: id to connect between client and server event
 *
 * currency - Type: string. Desc: currency
 *
 * hiddenVariantIds - Type: string. Desc: string with list of variants
 *
 * hiddenVariantsCount - Type: numeric. Desc: number of variants that were not synced
 *
 * imagesNum - Type: numeric. Desc: Num of images
 *
 * instanceId - Type: string. Desc: instanceId
 *
 * isBulk - Type: bool. Desc: is bulk action
 *
 * isDebug - Type: bool. Desc: is debug mode
 *
 * isDynamicPrice - Type: bool. Desc: Is dynamic price
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * isShippingInCost - Type: bool. Desc: Is shipping included in cost
 *
 * itemsCost - Type: string. Desc: JSON with variants origin prices
 *
 * mainImageUrl - Type: string. Desc: main_image_url
 *
 * marketplace - Type: string. Desc: RTS/POD
 *
 * modalystProductId - Type: string. Desc: modalyst_product_id
 *
 * modalystVariantIds - Type: string. Desc: List of variant ids
 *
 * bi_token - Type: guid. Desc: wix msid
 *
 * origin - Type: string. Desc: POD editor/draft list/product page
 *
 * productDescription - Type: string. Desc: Product description
 *
 * productName - Type: string. Desc: productName
 *
 * retailerPrices - Type: string. Desc: JSON with retailer prices
 *
 * retailerProductId - Type: string. Desc: retailerProductId. Null if bulk action
 *
 * retailerStorePlatform - Type: string. Desc: retailer store platform
 *
 * retailerVariantIds - Type: string. Desc: List of retailer variants id
 *
 * storeUrl - Type: string. Desc: site's url. Null for Wix users
 *
 * subscriptionPlanId - Type: string. Desc: package id in modalyst definition
 *
 * variantsCount - Type: numeric. Desc: number of variants
 * @param {addProductToSyncListClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addProductToSyncListClicked = function (params) {
    return { evid: 7, src: 145, endpoint: 'modalyst', params: params };
};
/**
* @typedef {Object} productAddedToSyncListParams
* @property {string} accountId - modalyst account id
* @property {string} businessId - modalyst business id
* @property {string} correlationId - id that helps connect between client and server events
* @property {string} currency - currency
* @property {string} instanceId - instanceId
* @property {boolean} isDebug - is debug mode
* @property {boolean} isDynamicPrice - is_dynamic_price
* @property {boolean} isPremium - is modalyst premium
* @property {boolean} isShippingInCost - is_shipping_in_cost
* @property {string} itemsCost - JSON with variants origin prices
* @property {string} marketplace - RTS/POD
* @property {string} modalystProductId - modalyst_product_id
* @property {string} modalystVariantIds - List of variant ids
* @property {string} origin - PODeditor/draft list/product page
* @property {string} pageName - marketplace/product page
* @property {string} productDescription - productDescription
* @property {string} productName - productName
* @property {string} retailerPrices - JSON with retailer prices
* @property {string} retailerProductId - retailerProductId
* @property {string} retailerStorePlatform - retailer store platform
* @property {string} retailerVariantIds - List of retailer variants id
* @property {number} shippingRate - shipping_rate
* @property {string} storeUrl - site's url. Null for Wix users
* @property {string} subscriptionPlanId - package id in modalyst definition
* @property {string} supplierId - supplier_id
* @property {string} supplierProductId - supplier_product_id
* @property {number} variantsCount - variantsCount
**/
/**
 * Name: Product Added to Sync List. Evid: 1005.
 * Event description: Product Added to Sync List.

 * accountId - Type: string. Desc: modalyst account id
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * correlationId - Type: string. Desc: id that helps connect between client and server events
 *
 * currency - Type: string. Desc: currency
 *
 * instanceId - Type: string. Desc: instanceId
 *
 * isDebug - Type: bool. Desc: is debug mode
 *
 * isDynamicPrice - Type: bool. Desc: is_dynamic_price
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * isShippingInCost - Type: bool. Desc: is_shipping_in_cost
 *
 * itemsCost - Type: string. Desc: JSON with variants origin prices
 *
 * marketplace - Type: string. Desc: RTS/POD
 *
 * modalystProductId - Type: string. Desc: modalyst_product_id
 *
 * modalystVariantIds - Type: string. Desc: List of variant ids
 *
 * origin - Type: string. Desc: PODeditor/draft list/product page
 *
 * pageName - Type: string. Desc: marketplace/product page
 *
 * productDescription - Type: string. Desc: productDescription
 *
 * productName - Type: string. Desc: productName
 *
 * retailerPrices - Type: string. Desc: JSON with retailer prices
 *
 * retailerProductId - Type: string. Desc: retailerProductId
 *
 * retailerStorePlatform - Type: string. Desc: retailer store platform
 *
 * retailerVariantIds - Type: string. Desc: List of retailer variants id
 *
 * shippingRate - Type: numeric. Desc: shipping_rate
 *
 * storeUrl - Type: string. Desc: site's url. Null for Wix users
 *
 * subscriptionPlanId - Type: string. Desc: package id in modalyst definition
 *
 * supplierId - Type: string. Desc: supplier_id
 *
 * supplierProductId - Type: string. Desc: supplier_product_id
 *
 * variantsCount - Type: numeric. Desc: variantsCount
 * @param {productAddedToSyncListParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var productAddedToSyncList = function (params) {
    return { evid: 1005, src: 145, endpoint: 'modalyst', params: params };
};
/**
* @typedef {Object} selectStoreClickedParams
* @property {string} accountId - null
* @property {string} businessId - modalyst business id
* @property {string} correlationId - correlation_id
* @property {string} instanceId - instanceId
* @property {boolean} isDebug - is debug mode
* @property {boolean} isPremium - is modalyst premium
* @property {GUID} msid - msid
* @property {string} origin - stores dropdown / my stores page
* @property {string} retailerStorePlatform - retailer store platform
* @property {string} storeName - the name of the store the user wants navigate to
* @property {string} storeUrl - site's url. Null for Wix users
* @property {string} subscriptionPlanId - package id in modalyst definition
* @property {GUID} targetStoreId - the id of the store the user wants navigate to
* @property {string} uuid - uuid
**/
/**
 * Name: Modalyst Multi-stores: Select Store Clicked. Evid: 21.
 * Event description: Select Store Clicked.

 * accountId - Type: string.
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * correlationId - Type: string. Desc: correlation_id
 *
 * instanceId - Type: string. Desc: instanceId
 *
 * isDebug - Type: bool. Desc: is debug mode
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: stores dropdown / my stores page
 *
 * retailerStorePlatform - Type: string. Desc: retailer store platform
 *
 * storeName - Type: string. Desc: the name of the store the user wants navigate to
 *
 * storeUrl - Type: string. Desc: site's url. Null for Wix users
 *
 * subscriptionPlanId - Type: string. Desc: package id in modalyst definition
 *
 * targetStoreId - Type: guid. Desc: the id of the store the user wants navigate to
 *
 * uuid - Type: string. Desc: uuid
 * @param {selectStoreClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var selectStoreClicked = function (params) {
    return { evid: 21, src: 145, endpoint: 'modalyst', params: params };
};
/**
* @typedef {Object} autoPriceStatusChangedParams
* @property {string} accountId - modalyst account id
* @property {string} businessId - modalyst business id
* @property {string} correlationId - correlation_id
* @property {string} instanceId - instanceId
* @property {boolean} isBulk - is bulk action
* @property {boolean} isDebug - is debug mode
* @property {boolean} isPremium - is modalyst premium
* @property {string} marketplace - RTS/POD
* @property {string} modalystProductId - modalyst_product_id
* @property {string} modalystVariantIds - List of variant ids
* @property {GUID} bi_token - wix msid
* @property {string} origin - Import list/synced products list
* @property {string} productName - product_name
* @property {string} retailerProductId - retailerProductId
* @property {string} retailerStorePlatform - retailer store platform
* @property {string} retailerVariantIds - List of retailer variants id
* @property {string} selectionType - toggle/auto price on button/auto price off button/auto(after user change price manually)
* @property {boolean} status - auto price status
* @property {string} storeUrl - site's url. Null for Wix users
* @property {string} subscriptionPlanId - package id in modalyst definition
* @property {string} supplierId - supplier Id
* @property {string} supplierProductId - supplier ProductI d
* @property {number} variantsCount - Number of variants
**/
/**
 * Name: Auto price status changed. Evid: 9.
 * Event description: When user changed auto price status.

 * accountId - Type: string. Desc: modalyst account id
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * correlationId - Type: string. Desc: correlation_id
 *
 * instanceId - Type: string. Desc: instanceId
 *
 * isBulk - Type: bool. Desc: is bulk action
 *
 * isDebug - Type: bool. Desc: is debug mode
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * marketplace - Type: string. Desc: RTS/POD
 *
 * modalystProductId - Type: string. Desc: modalyst_product_id
 *
 * modalystVariantIds - Type: string. Desc: List of variant ids
 *
 * bi_token - Type: guid. Desc: wix msid
 *
 * origin - Type: string. Desc: Import list/synced products list
 *
 * productName - Type: string. Desc: product_name
 *
 * retailerProductId - Type: string. Desc: retailerProductId
 *
 * retailerStorePlatform - Type: string. Desc: retailer store platform
 *
 * retailerVariantIds - Type: string. Desc: List of retailer variants id
 *
 * selectionType - Type: string. Desc: toggle/auto price on button/auto price off button/auto(after user change price manually)
 *
 * status - Type: bool. Desc: auto price status
 *
 * storeUrl - Type: string. Desc: site's url. Null for Wix users
 *
 * subscriptionPlanId - Type: string. Desc: package id in modalyst definition
 *
 * supplierId - Type: string. Desc: supplier Id
 *
 * supplierProductId - Type: string. Desc: supplier ProductI d
 *
 * variantsCount - Type: numeric. Desc: Number of variants
 * @param {autoPriceStatusChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var autoPriceStatusChanged = function (params) {
    return { evid: 9, src: 145, endpoint: 'modalyst', params: params };
};
/**
* @typedef {Object} unsyncProductClickedParams
* @property {string} accountId - modalyst account id
* @property {string} businessId - modalyst business id
* @property {string} correlationId - id to connect between client and server event
* @property {string} instanceId - instanceId
* @property {boolean} isBulk - is bulk action
* @property {boolean} isDebug - is debug mode
* @property {boolean} isPremium - is modalyst premium
* @property {string} marketplace - RTS/POD
* @property {string} modalystProductId - modalyst_product_id
* @property {string} modalystVariantIds - List of variant ids
* @property {GUID} bi_token - wix msid
* @property {string} origin - POD editor/draft list/product page
* @property {string} retailerProductId - retailerProductId
* @property {string} retailerStorePlatform - retailer store platform
* @property {string} retailerVariantIds - List of retailer variants id
* @property {string} storeUrl - site's url. Null for Wix users
* @property {string} subscriptionPlanId - package id in modalyst definition
**/
/**
 * Name: Unsync product clicked. Evid: 8.
 * Event description: When user clicked to unsync product from sync list.

 * accountId - Type: string. Desc: modalyst account id
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * correlationId - Type: string. Desc: id to connect between client and server event
 *
 * instanceId - Type: string. Desc: instanceId
 *
 * isBulk - Type: bool. Desc: is bulk action
 *
 * isDebug - Type: bool. Desc: is debug mode
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * marketplace - Type: string. Desc: RTS/POD
 *
 * modalystProductId - Type: string. Desc: modalyst_product_id
 *
 * modalystVariantIds - Type: string. Desc: List of variant ids
 *
 * bi_token - Type: guid. Desc: wix msid
 *
 * origin - Type: string. Desc: POD editor/draft list/product page
 *
 * retailerProductId - Type: string. Desc: retailerProductId
 *
 * retailerStorePlatform - Type: string. Desc: retailer store platform
 *
 * retailerVariantIds - Type: string. Desc: List of retailer variants id
 *
 * storeUrl - Type: string. Desc: site's url. Null for Wix users
 *
 * subscriptionPlanId - Type: string. Desc: package id in modalyst definition
 * @param {unsyncProductClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var unsyncProductClicked = function (params) {
    return { evid: 8, src: 145, endpoint: 'modalyst', params: params };
};
/**
* @typedef {Object} pageLoadedParams
* @property {string} accountId - modalyst account id
* @property {string} businessId - modalyst business id
* @property {string} instanceId - instanceId
* @property {boolean} isDebug - is debug mode
* @property {boolean} isPremium - is modalyst premium
* @property {string} marketplace - RTS/POD
* @property {string} modalystProductId - modalyst_product_id
* @property {string} pageName - marketplace/product page
* @property {string} retailerStorePlatform - retailer store platform
* @property {string} storeUrl - site's url. Null for Wix users
* @property {string} subscriptionPlanId - package id in modalyst definition
* @property {string} supplierProductId - supplier_product_id
**/
/**
 * Name: Page Loaded. Evid: 1002.
 * Event description: Page Loaded.

 * accountId - Type: string. Desc: modalyst account id
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * instanceId - Type: string. Desc: instanceId
 *
 * isDebug - Type: bool. Desc: is debug mode
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * marketplace - Type: string. Desc: RTS/POD
 *
 * modalystProductId - Type: string. Desc: modalyst_product_id
 *
 * pageName - Type: string. Desc: marketplace/product page
 *
 * retailerStorePlatform - Type: string. Desc: retailer store platform
 *
 * storeUrl - Type: string. Desc: site's url. Null for Wix users
 *
 * subscriptionPlanId - Type: string. Desc: package id in modalyst definition
 *
 * supplierProductId - Type: string. Desc: supplier_product_id
 * @param {pageLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pageLoaded = function (params) {
    return { evid: 1002, src: 145, endpoint: 'modalyst', params: params };
};
/**
* @typedef {Object} logOutClickedParams
* @property {string} accountId - modalyst account id
* @property {string} businessId - modalyst business id
* @property {string} correlationId - correlation_id
* @property {string} instanceId - instanceId
* @property {boolean} isDebug - is debug mode
* @property {boolean} isPremium - is modalyst premium
* @property {GUID} msid - msid
* @property {string} origin - main panel/ top actions
* @property {string} retailerStorePlatform - retailer store platform
* @property {string} storeUrl - site's url. Null for Wix users
* @property {string} subscriptionPlanId - package id in modalyst definition
* @property {string} uuid - uuid
**/
/**
 * Name: Modalyst Multi-stores: Log Out Clicked. Evid: 34.
 * Event description: User Profile Clicked.

 * accountId - Type: string. Desc: modalyst account id
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * correlationId - Type: string. Desc: correlation_id
 *
 * instanceId - Type: string. Desc: instanceId
 *
 * isDebug - Type: bool. Desc: is debug mode
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: main panel/ top actions
 *
 * retailerStorePlatform - Type: string. Desc: retailer store platform
 *
 * storeUrl - Type: string. Desc: site's url. Null for Wix users
 *
 * subscriptionPlanId - Type: string. Desc: package id in modalyst definition
 *
 * uuid - Type: string. Desc: uuid
 * @param {logOutClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var logOutClicked = function (params) {
    return { evid: 34, src: 145, endpoint: 'modalyst', params: params };
};
/**
* @typedef {Object} addNewStoreModalShownParams
* @property {string} accountId - modalyst account id
* @property {string} businessId - modalyst business id
* @property {string} correlationId - correlation_id
* @property {string} instanceId - instanceId
* @property {boolean} isDebug - is debug mode
* @property {boolean} isPremium - is modalyst premium
* @property {GUID} msid - msid
* @property {string} origin - sign up/retailer
* @property {string} retailerStorePlatform - retailer store platform
* @property {string} storeUrl - site's url. Null for Wix users
* @property {string} subscriptionPlanId - null
* @property {string} uuid - uuid
**/
/**
 * Name: Modalyst Multi-stores: New Store Modal -> shown. Evid: 17.


 * accountId - Type: string. Desc: modalyst account id
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * correlationId - Type: string. Desc: correlation_id
 *
 * instanceId - Type: string. Desc: instanceId
 *
 * isDebug - Type: bool. Desc: is debug mode
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: sign up/retailer
 *
 * retailerStorePlatform - Type: string. Desc: retailer store platform
 *
 * storeUrl - Type: string. Desc: site's url. Null for Wix users
 *
 * subscriptionPlanId - Type: string.
 *
 * uuid - Type: string. Desc: uuid
 * @param {addNewStoreModalShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addNewStoreModalShown = function (params) {
    return { evid: 17, src: 145, endpoint: 'modalyst', params: params };
};
/**
* @typedef {Object} goToMyStoresClickedParams
* @property {string} accountId - modalyst account id
* @property {string} businessId - modalyst business id
* @property {string} correlationId - correlation id
* @property {string} instanceId - instanceId
* @property {boolean} isDebug - is debug mode
* @property {boolean} isPremium - is modalyst premium
* @property {GUID} msid - msid
* @property {string} origin - store selector/main navigation
* @property {string} retailerStorePlatform - retailer store platform
* @property {string} storeUrl - site's url. Null for Wix users
* @property {string} subscriptionPlanId - package id in modalyst definition
* @property {string} uuid - uuid
**/
/**
 * Name: Modalyst Multi-stores: Go To My Store Clicked. Evid: 20.
 * Event description: Go To My Store Clicked.

 * accountId - Type: string. Desc: modalyst account id
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * correlationId - Type: string. Desc: correlation id
 *
 * instanceId - Type: string. Desc: instanceId
 *
 * isDebug - Type: bool. Desc: is debug mode
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: store selector/main navigation
 *
 * retailerStorePlatform - Type: string. Desc: retailer store platform
 *
 * storeUrl - Type: string. Desc: site's url. Null for Wix users
 *
 * subscriptionPlanId - Type: string. Desc: package id in modalyst definition
 *
 * uuid - Type: string. Desc: uuid
 * @param {goToMyStoresClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var goToMyStoresClicked = function (params) {
    return { evid: 20, src: 145, endpoint: 'modalyst', params: params };
};
/**
* @typedef {Object} productSearchCategoryClickedParams
* @property {string} accountId - modalyst account id
* @property {string} businessId - modalyst business id
* @property {string} categoryPath - List of categories user chosen (in order by hierarchy) - path
* @property {string} correlationId - correlation_id
* @property {string} instanceId - instanceId
* @property {boolean} isDebug - is debug mode
* @property {boolean} isPremium - is modalyst premium
* @property {string} marketplace - RTS/POD
* @property {GUID} msid - wix msid
* @property {number} pathLength - number of levels in the hierarchy
* @property {number} resultsNum - supplier_product_id
* @property {string} retailerStorePlatform - retailer store platform
* @property {string} storeUrl - site's url. Null for Wix users
* @property {string} subscriptionPlanId - package id in modalyst definition
**/
/**
 * Name: Product Search: Category clicked. Evid: 2.
 * Event description: When user clicked on category in the category tabs.

 * accountId - Type: string. Desc: modalyst account id
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * categoryPath - Type: string. Desc: List of categories user chosen (in order by hierarchy) - path
 *
 * correlationId - Type: string. Desc: correlation_id
 *
 * instanceId - Type: string. Desc: instanceId
 *
 * isDebug - Type: bool. Desc: is debug mode
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * marketplace - Type: string. Desc: RTS/POD
 *
 * msid - Type: guid. Desc: wix msid
 *
 * pathLength - Type: numeric. Desc: number of levels in the hierarchy
 *
 * resultsNum - Type: numeric. Desc: supplier_product_id
 *
 * retailerStorePlatform - Type: string. Desc: retailer store platform
 *
 * storeUrl - Type: string. Desc: site's url. Null for Wix users
 *
 * subscriptionPlanId - Type: string. Desc: package id in modalyst definition
 * @param {productSearchCategoryClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var productSearchCategoryClicked = function (params) {
    return { evid: 2, src: 145, endpoint: 'modalyst', params: params };
};
/**
* @typedef {Object} storeSelectorTriggeredParams
* @property {string} accountId - modalyst account id
* @property {string} businessId - modalyst business id
* @property {string} correlationId - correlation_id
* @property {string} instanceId - instanceId
* @property {boolean} isDebug - is debug mode
* @property {boolean} isPremium - is modalyst premium
* @property {GUID} msid - msid
* @property {string} retailerStorePlatform - retailer store platform
* @property {string} storeUrl - site's url. Null for Wix users
* @property {string} subscriptionPlanId - package id in modalyst definition
* @property {string} uuid - uuid
**/
/**
 * Name: Modalyst Multi-stores: Stores Dropdown Clicked. Evid: 15.
 * Event description: Stores Dropdown Clicked.

 * accountId - Type: string. Desc: modalyst account id
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * correlationId - Type: string. Desc: correlation_id
 *
 * instanceId - Type: string. Desc: instanceId
 *
 * isDebug - Type: bool. Desc: is debug mode
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * msid - Type: guid. Desc: msid
 *
 * retailerStorePlatform - Type: string. Desc: retailer store platform
 *
 * storeUrl - Type: string. Desc: site's url. Null for Wix users
 *
 * subscriptionPlanId - Type: string. Desc: package id in modalyst definition
 *
 * uuid - Type: string. Desc: uuid
 * @param {storeSelectorTriggeredParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var storeSelectorTriggered = function (params) {
    return { evid: 15, src: 145, endpoint: 'modalyst', params: params };
};
/**
* @typedef {Object} connectStoreClickedParams
* @property {string} accountId - modalyst account id
* @property {string} businessId - modalyst business id
* @property {string} correlationId - correlation_id
* @property {string} instanceId - instanceId
* @property {boolean} isDebug - is debug mode
* @property {boolean} isPremium - is modalyst premium
* @property {GUID} msid - msid
* @property {string} origin - store card/ 3dots button/ alert
* @property {string} retailerStorePlatform - retailer store platform
* @property {string} storeName - the name of the store the user wants to disconnect
* @property {string} storeUrl - site's url. Null for Wix users
* @property {string} subscriptionPlanId - package id in modalyst definition
* @property {GUID} targetStoreId - id of the store users try to connect
* @property {string} uuid - uuid
**/
/**
 * Name: Modalyst Multi-stores: Connect store Clicked. Evid: 29.
 * Event description: Multi-stores: Connect store Clicked.

 * accountId - Type: string. Desc: modalyst account id
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * correlationId - Type: string. Desc: correlation_id
 *
 * instanceId - Type: string. Desc: instanceId
 *
 * isDebug - Type: bool. Desc: is debug mode
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: store card/ 3dots button/ alert
 *
 * retailerStorePlatform - Type: string. Desc: retailer store platform
 *
 * storeName - Type: string. Desc: the name of the store the user wants to disconnect
 *
 * storeUrl - Type: string. Desc: site's url. Null for Wix users
 *
 * subscriptionPlanId - Type: string. Desc: package id in modalyst definition
 *
 * targetStoreId - Type: guid. Desc: id of the store users try to connect
 *
 * uuid - Type: string. Desc: uuid
 * @param {connectStoreClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var connectStoreClicked = function (params) {
    return { evid: 29, src: 145, endpoint: 'modalyst', params: params };
};
/**
* @typedef {Object} orderFulfilledParams
* @property {string} accountId - modalyst account id
* @property {string} businessId - modalyst business id
* @property {string} carrierName - Courier name
* @property {DateTime} estimatedDeliveryDate - Estimated delivery date
* @property {string} instanceId - instanceId
* @property {boolean} isDebug - is debug mode
* @property {boolean} isManual - is_manual
* @property {boolean} isPremium - is modalyst premium
* @property {boolean} isShippingInCost - Is shipping included to cost
* @property {number} itemCost - Original cost
* @property {number} itemsQuantity - Total variants
* @property {string} marketplace - RTS/POD
* @property {string} modalystOrderId - Unic id from modalyst site
* @property {number} modalystOrderNumber - number that is displayed for user in interface
* @property {string} modalystProductId - modalyst_product_id
* @property {string} modalystProductIds - modalyst_product_ids in order
* @property {number} modalystServiceFee - Modalyst_service_fee (retailer)
* @property {number} numItems - Distinct variants
* @property {number} numProducts - Distinct products
* @property {string} retailerOrderId - Retailer_order_id (wix)
* @property {string} retailerProductId - retailerProductId
* @property {string} retailerProductIds - list of retailer products ids in order
* @property {string} retailerStorePlatform - retailer store platform
* @property {number} shippingRate - Shipping cost
* @property {string} subscriptionPlanId - package id in modalyst definition
* @property {string} supplierId - supplier_id
* @property {string} supplierProductId - supplier_product_id
* @property {string} supplierProductIds - list with Supplier product ids in order
* @property {number} totalAmount - Retail order price (total price)
* @property {string} trackingNumber - Tracking number
* @property {string} url - site's url. Null for Wix users
**/
/**
 * Name: Order fulfilled. Evid: 1010.
 * Event description: Order Fulfilled.

 * accountId - Type: string. Desc: modalyst account id
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * carrierName - Type: string. Desc: Courier name
 *
 * estimatedDeliveryDate - Type: datetime. Desc: Estimated delivery date
 *
 * instanceId - Type: string. Desc: instanceId
 *
 * isDebug - Type: bool. Desc: is debug mode
 *
 * isManual - Type: bool. Desc: is_manual
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * isShippingInCost - Type: bool. Desc: Is shipping included to cost
 *
 * itemCost - Type: numeric. Desc: Original cost
 *
 * itemsQuantity - Type: numeric. Desc: Total variants
 *
 * marketplace - Type: string. Desc: RTS/POD
 *
 * modalystOrderId - Type: string. Desc: Unic id from modalyst site
 *
 * modalystOrderNumber - Type: numeric. Desc: number that is displayed for user in interface
 *
 * modalystProductId - Type: string. Desc: modalyst_product_id
 *
 * modalystProductIds - Type: string. Desc: modalyst_product_ids in order
 *
 * modalystServiceFee - Type: numeric. Desc: Modalyst_service_fee (retailer)
 *
 * numItems - Type: numeric. Desc: Distinct variants
 *
 * numProducts - Type: numeric. Desc: Distinct products
 *
 * retailerOrderId - Type: string. Desc: Retailer_order_id (wix)
 *
 * retailerProductId - Type: string. Desc: retailerProductId
 *
 * retailerProductIds - Type: string. Desc: list of retailer products ids in order
 *
 * retailerStorePlatform - Type: string. Desc: retailer store platform
 *
 * shippingRate - Type: numeric. Desc: Shipping cost
 *
 * subscriptionPlanId - Type: string. Desc: package id in modalyst definition
 *
 * supplierId - Type: string. Desc: supplier_id
 *
 * supplierProductId - Type: string. Desc: supplier_product_id
 *
 * supplierProductIds - Type: string. Desc: list with Supplier product ids in order
 *
 * totalAmount - Type: numeric. Desc: Retail order price (total price)
 *
 * trackingNumber - Type: string. Desc: Tracking number
 *
 * url - Type: string. Desc: site's url. Null for Wix users
 * @param {orderFulfilledParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var orderFulfilled = function (params) {
    return { evid: 1010, src: 145, endpoint: 'modalyst', params: params };
};
/**
* @typedef {Object} deleteStoreConfirmModalShownParams
* @property {string} accountId - modalyst account id
* @property {string} businessId - modalyst business id
* @property {string} correlationId - correlation_id
* @property {string} instanceId - instanceId
* @property {boolean} isDebug - null
* @property {boolean} isPremium - is modalyst premium
* @property {GUID} msid - msid
* @property {string} retailerStorePlatform - retailer store platform
* @property {string} storeName - the name of the store the user wants to delete
* @property {string} storeUrl - site's url. Null for Wix users
* @property {string} subscriptionPlanId - package id in modalyst definition
* @property {GUID} targetStoreId - the id of the store the user wants to delete
* @property {string} uuid - uuid
**/
/**
 * Name: Modalyst Multi-stores:Delete store Modal -> shown. Evid: 24.
 * Event description: Delete store Modal -> loaded.

 * accountId - Type: string. Desc: modalyst account id
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * correlationId - Type: string. Desc: correlation_id
 *
 * instanceId - Type: string. Desc: instanceId
 *
 * isDebug - Type: bool.
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * msid - Type: guid. Desc: msid
 *
 * retailerStorePlatform - Type: string. Desc: retailer store platform
 *
 * storeName - Type: string. Desc: the name of the store the user wants to delete
 *
 * storeUrl - Type: string. Desc: site's url. Null for Wix users
 *
 * subscriptionPlanId - Type: string. Desc: package id in modalyst definition
 *
 * targetStoreId - Type: guid. Desc: the id of the store the user wants to delete
 *
 * uuid - Type: string. Desc: uuid
 * @param {deleteStoreConfirmModalShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var deleteStoreConfirmModalShown = function (params) {
    return { evid: 24, src: 145, endpoint: 'modalyst', params: params };
};
/**
* @typedef {Object} viewProductDetailsClickedParams
* @property {string} accountId - modalyst account id
* @property {string} appliedFilters - Applied filters when product was selected
* @property {string} businessId - modalyst business id
* @property {string} correlationId - correlation_id
* @property {string} instanceId - instanceId
* @property {boolean} isDebug - is debug mode
* @property {boolean} isPremium - is modalyst premium
* @property {string} marketplace - RTS/POD
* @property {string} modalystProductId - modalyst_product_id
* @property {string} ordering - Applied sorting when product was clicked
* @property {string} origin - dashboard / sync list
* @property {number} position - Product position in page
* @property {string} productName - productName
* @property {string} retailerProductId - retailerProductId
* @property {string} retailerStorePlatform - retailer store platform
* @property {string} storeUrl - site's url. Null for Wix users
* @property {string} subscriptionPlanId - package id in modalyst definition
* @property {string} supplierProductId - supplier_product_id
* @property {string} url - site's url. Null for Wix users
**/
/**
 * Name: View Product Details Clicked. Evid: 3.
 * Event description: When user clicks on view product details.

 * accountId - Type: string. Desc: modalyst account id
 *
 * appliedFilters - Type: string. Desc: Applied filters when product was selected
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * correlationId - Type: string. Desc: correlation_id
 *
 * instanceId - Type: string. Desc: instanceId
 *
 * isDebug - Type: bool. Desc: is debug mode
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * marketplace - Type: string. Desc: RTS/POD
 *
 * modalystProductId - Type: string. Desc: modalyst_product_id
 *
 * ordering - Type: string. Desc: Applied sorting when product was clicked
 *
 * origin - Type: string. Desc: dashboard / sync list
 *
 * position - Type: numeric. Desc: Product position in page
 *
 * productName - Type: string. Desc: productName
 *
 * retailerProductId - Type: string. Desc: retailerProductId
 *
 * retailerStorePlatform - Type: string. Desc: retailer store platform
 *
 * storeUrl - Type: string. Desc: site's url. Null for Wix users
 *
 * subscriptionPlanId - Type: string. Desc: package id in modalyst definition
 *
 * supplierProductId - Type: string. Desc: supplier_product_id
 *
 * url - Type: string. Desc: site's url. Null for Wix users
 * @param {viewProductDetailsClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var viewProductDetailsClicked = function (params) {
    return { evid: 3, src: 145, endpoint: 'modalyst', params: params };
};
/**
* @typedef {Object} orderSampleClickedParams
* @property {string} accountId - modalyst account id
* @property {string} businessId - modalyst business id
* @property {string} correlationId - correlation_id
* @property {string} instanceId - instanceId
* @property {boolean} isDebug - is debug mode
* @property {boolean} isPremium - is modalyst premium
* @property {string} marketplace - RTS/POD
* @property {string} modalystProductId - modalyst_product_id
* @property {string} modalystVariantIds - List of variant ids
* @property {GUID} bi_token - wix msid
* @property {string} origin - Import list/synced products list/product page
* @property {string} productName - product_name
* @property {string} retailerProductId - retailerProductId
* @property {string} retailerStorePlatform - retailer store platform
* @property {string} retailerVariantIds - List of retailer variants id
* @property {string} storeUrl - site's url. Null for Wix users
* @property {string} subscriptionPlanId - package id in modalyst definition
* @property {string} supplierId - supplier Id
* @property {string} supplierProductId - supplier ProductI d
* @property {number} variantsCount - Number of variants in the order / sample order
**/
/**
 * Name: Order Sample Clicked. Evid: 11.
 * Event description: When user clicked on order sample.

 * accountId - Type: string. Desc: modalyst account id
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * correlationId - Type: string. Desc: correlation_id
 *
 * instanceId - Type: string. Desc: instanceId
 *
 * isDebug - Type: bool. Desc: is debug mode
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * marketplace - Type: string. Desc: RTS/POD
 *
 * modalystProductId - Type: string. Desc: modalyst_product_id
 *
 * modalystVariantIds - Type: string. Desc: List of variant ids
 *
 * bi_token - Type: guid. Desc: wix msid
 *
 * origin - Type: string. Desc: Import list/synced products list/product page
 *
 * productName - Type: string. Desc: product_name
 *
 * retailerProductId - Type: string. Desc: retailerProductId
 *
 * retailerStorePlatform - Type: string. Desc: retailer store platform
 *
 * retailerVariantIds - Type: string. Desc: List of retailer variants id
 *
 * storeUrl - Type: string. Desc: site's url. Null for Wix users
 *
 * subscriptionPlanId - Type: string. Desc: package id in modalyst definition
 *
 * supplierId - Type: string. Desc: supplier Id
 *
 * supplierProductId - Type: string. Desc: supplier ProductI d
 *
 * variantsCount - Type: numeric. Desc: Number of variants in the order / sample order
 * @param {orderSampleClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var orderSampleClicked = function (params) {
    return { evid: 11, src: 145, endpoint: 'modalyst', params: params };
};
/**
* @typedef {Object} deleteStoreClickedParams
* @property {string} accountId - modalyst account id
* @property {string} businessId - modalyst business id
* @property {string} correlationId - correlation_id
* @property {string} instanceId - instanceId
* @property {boolean} isDebug - is debug mode
* @property {boolean} isPremium - is modalyst premium
* @property {GUID} msid - msid
* @property {string} origin - stores list
* @property {string} retailerStorePlatform - retailer store platform
* @property {string} storeName - the name of the store the user wants to delete
* @property {string} storeUrl - site's url. Null for Wix users
* @property {string} subscriptionPlanId - package id in modalyst definition
* @property {GUID} targetStoreId - the id of the store the user wants to delete
* @property {string} uuid - uuid
**/
/**
 * Name: Modalyst Multi-stores: Delete store Clicked. Evid: 23.
 * Event description: Delete store Clicked.

 * accountId - Type: string. Desc: modalyst account id
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * correlationId - Type: string. Desc: correlation_id
 *
 * instanceId - Type: string. Desc: instanceId
 *
 * isDebug - Type: bool. Desc: is debug mode
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: stores list
 *
 * retailerStorePlatform - Type: string. Desc: retailer store platform
 *
 * storeName - Type: string. Desc: the name of the store the user wants to delete
 *
 * storeUrl - Type: string. Desc: site's url. Null for Wix users
 *
 * subscriptionPlanId - Type: string. Desc: package id in modalyst definition
 *
 * targetStoreId - Type: guid. Desc: the id of the store the user wants to delete
 *
 * uuid - Type: string. Desc: uuid
 * @param {deleteStoreClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var deleteStoreClicked = function (params) {
    return { evid: 23, src: 145, endpoint: 'modalyst', params: params };
};
/**
* @typedef {Object} productDraftSavedParams
* @property {string} accountId - modalyst account id
* @property {string} businessId - modalyst business id
* @property {string} instanceId - instanceId
* @property {boolean} isDebug - is debug mode
* @property {boolean} isPremium - is modalyst premium
* @property {string} marketplace - RTS/POD
* @property {string} modalystProductId - modalyst_product_id
* @property {string} origin - marketplace/product page
* @property {string} productName - productName
* @property {string} retailerProductId - retailerProductId
* @property {string} retailerStorePlatform - retailer store platform
* @property {string} storeUrl - site's url. Null for Wix users
* @property {string} subscriptionPlanId - package id in modalyst definition
* @property {string} supplierProductId - supplier_product_id
**/
/**
 * Name: Product Draft Saved. Evid: 1003.
 * Event description: Product Draft Saved.

 * accountId - Type: string. Desc: modalyst account id
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * instanceId - Type: string. Desc: instanceId
 *
 * isDebug - Type: bool. Desc: is debug mode
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * marketplace - Type: string. Desc: RTS/POD
 *
 * modalystProductId - Type: string. Desc: modalyst_product_id
 *
 * origin - Type: string. Desc: marketplace/product page
 *
 * productName - Type: string. Desc: productName
 *
 * retailerProductId - Type: string. Desc: retailerProductId
 *
 * retailerStorePlatform - Type: string. Desc: retailer store platform
 *
 * storeUrl - Type: string. Desc: site's url. Null for Wix users
 *
 * subscriptionPlanId - Type: string. Desc: package id in modalyst definition
 *
 * supplierProductId - Type: string. Desc: supplier_product_id
 * @param {productDraftSavedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var productDraftSaved = function (params) {
    return { evid: 1003, src: 145, endpoint: 'modalyst', params: params };
};
/**
* @typedef {Object} sendOrderToFulfillerParams
* @property {string} accountId - modalyst account id
* @property {string} businessId - modalyst business id
* @property {string} errorDescription - errorDescription
* @property {string} externalOrderId - External order id
* @property {string} instanceId - null
* @property {boolean} isDebug - is debug mode
* @property {boolean} isManual - Is order placed manually by retailer
* @property {boolean} isPremium - is modalyst premium
* @property {boolean} isShippingInCost - Is shipping included to cost
* @property {boolean} isSuccess - isSuccess
* @property {number} itemCost - Original cost
* @property {number} itemsQuantity - Total variants
* @property {string} marketplace - RTS/POD
* @property {string} modalystOrderId - Unic id from modalyst site
* @property {number} modalystOrderNumber - number that is displayed for user in interface
* @property {string} modalystProductId - modalyst_product_id
* @property {string} modalystProductIds - list with modalyst_product_ids in order
* @property {number} modalystServiceFee - Modalyst_service_fee (retailer)
* @property {number} numItems - Distinct variants
* @property {number} numProducts - Distinct products
* @property {string} retailerOrderId - Retailer_order_id (wix)
* @property {string} retailerProductIds - list of retailer products ids in order
* @property {string} retailerStorePlatform - retailer store platform
* @property {number} shippingRate - Shipping cost
* @property {string} subscriptionPlanId - package id in modalyst definition
* @property {string} supplierId - supplier_id
* @property {string} supplierProductId - supplier_product_id
* @property {string} supplierProductIds - list with Supplier product ids in order
* @property {number} totalAmount - Retail order price (total price)
* @property {string} trackingNumber - Tracking number
**/
/**
 * Name: Send order to fulfiller. Evid: 1009.
 * Event description: Send order to fulfiller.

 * accountId - Type: string. Desc: modalyst account id
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * errorDescription - Type: string. Desc: errorDescription
 *
 * externalOrderId - Type: string. Desc: External order id
 *
 * instanceId - Type: string.
 *
 * isDebug - Type: bool. Desc: is debug mode
 *
 * isManual - Type: bool. Desc: Is order placed manually by retailer
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * isShippingInCost - Type: bool. Desc: Is shipping included to cost
 *
 * isSuccess - Type: bool. Desc: isSuccess
 *
 * itemCost - Type: numeric. Desc: Original cost
 *
 * itemsQuantity - Type: numeric. Desc: Total variants
 *
 * marketplace - Type: string. Desc: RTS/POD
 *
 * modalystOrderId - Type: string. Desc: Unic id from modalyst site
 *
 * modalystOrderNumber - Type: numeric. Desc: number that is displayed for user in interface
 *
 * modalystProductId - Type: string. Desc: modalyst_product_id
 *
 * modalystProductIds - Type: string. Desc: list with modalyst_product_ids in order
 *
 * modalystServiceFee - Type: numeric. Desc: Modalyst_service_fee (retailer)
 *
 * numItems - Type: numeric. Desc: Distinct variants
 *
 * numProducts - Type: numeric. Desc: Distinct products
 *
 * retailerOrderId - Type: string. Desc: Retailer_order_id (wix)
 *
 * retailerProductIds - Type: string. Desc: list of retailer products ids in order
 *
 * retailerStorePlatform - Type: string. Desc: retailer store platform
 *
 * shippingRate - Type: numeric. Desc: Shipping cost
 *
 * subscriptionPlanId - Type: string. Desc: package id in modalyst definition
 *
 * supplierId - Type: string. Desc: supplier_id
 *
 * supplierProductId - Type: string. Desc: supplier_product_id
 *
 * supplierProductIds - Type: string. Desc: list with Supplier product ids in order
 *
 * totalAmount - Type: numeric. Desc: Retail order price (total price)
 *
 * trackingNumber - Type: string. Desc: Tracking number
 * @param {sendOrderToFulfillerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sendOrderToFulfiller = function (params) {
    return { evid: 1009, src: 145, endpoint: 'modalyst', params: params };
};
/**
* @typedef {Object} addProductToImportListClickedParams
* @property {string} accountId - modalyst account id
* @property {string} appliedFilters - Applied filters when product was selected
* @property {string} businessId - modalyst business id
* @property {string} correlationId - id to connect between client and server event
* @property {string} currency - currency
* @property {number} imagesNum - Num of images
* @property {string} instanceId - instanceId
* @property {boolean} isDebug - is debug mode
* @property {boolean} isDynamicPrice - Is dynamic price
* @property {boolean} isPremium - is modalyst premium
* @property {boolean} isShippingInCost - Is shipping included in cost
* @property {string} itemsCost - JSON with variants origin prices
* @property {string} mainImageUrl - main_image_url
* @property {string} marketplace - RTS/POD
* @property {string} modalystProductId - modalyst_product_id
* @property {string} modalystVariantIds - List of variant ids
* @property {string} options - size/color
* @property {string} ordering - Applied sorting when product was clicked
* @property {string} origin - dashboard / sync list
* @property {number} podDistinctImagesUploaded - Number of unique  uploaded POD images (from editor)
* @property {string} podImagesDetails - JSON: front:3, back:5
* @property {number} podTextAdded - Num of added text
* @property {number} podTotalImagesUploaded - Number of total uploaded POD images
* @property {number} position - Product position in page
* @property {string} productCategory - Product category from search. null if origin is product page or draft list
* @property {string} productDescription - Product description
* @property {string} productName - productName
* @property {string} productTags - Product tags
* @property {string} productTypes - Product types
* @property {string} retailerPrices - JSON with retailer prices
* @property {string} retailerProductId - retailerProductId
* @property {string} retailerStorePlatform - retailer store platform
* @property {string} retailerVariantIds - List of retailer variants id
* @property {string} searchTerm - Search term by which user find this product (null if origin is product page or drafts list)
* @property {number} shippingRate - shipping Rate for retailer (main) country
* @property {string} storeUrl - site's url. Null for Wix users
* @property {string} subscriptionPlanId - package id in modalyst definition
* @property {string} supplierId - supplier_id
* @property {number} variantsCount - number of variants
**/
/**
 * Name: Add Product To Import List Clicked. Evid: 5.
 * Event description: When user clicked to add product to import list.

 * accountId - Type: string. Desc: modalyst account id
 *
 * appliedFilters - Type: string. Desc: Applied filters when product was selected
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * correlationId - Type: string. Desc: id to connect between client and server event
 *
 * currency - Type: string. Desc: currency
 *
 * imagesNum - Type: numeric. Desc: Num of images
 *
 * instanceId - Type: string. Desc: instanceId
 *
 * isDebug - Type: bool. Desc: is debug mode
 *
 * isDynamicPrice - Type: bool. Desc: Is dynamic price
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * isShippingInCost - Type: bool. Desc: Is shipping included in cost
 *
 * itemsCost - Type: string. Desc: JSON with variants origin prices
 *
 * mainImageUrl - Type: string. Desc: main_image_url
 *
 * marketplace - Type: string. Desc: RTS/POD
 *
 * modalystProductId - Type: string. Desc: modalyst_product_id
 *
 * modalystVariantIds - Type: string. Desc: List of variant ids
 *
 * options - Type: string. Desc: size/color
 *
 * ordering - Type: string. Desc: Applied sorting when product was clicked
 *
 * origin - Type: string. Desc: dashboard / sync list
 *
 * podDistinctImagesUploaded - Type: numeric. Desc: Number of unique  uploaded POD images (from editor)
 *
 * podImagesDetails - Type: string. Desc: JSON: front:3, back:5
 *
 * podTextAdded - Type: numeric. Desc: Num of added text
 *
 * podTotalImagesUploaded - Type: numeric. Desc: Number of total uploaded POD images
 *
 * position - Type: numeric. Desc: Product position in page
 *
 * productCategory - Type: string. Desc: Product category from search. null if origin is product page or draft list
 *
 * productDescription - Type: string. Desc: Product description
 *
 * productName - Type: string. Desc: productName
 *
 * productTags - Type: string. Desc: Product tags
 *
 * productTypes - Type: string. Desc: Product types
 *
 * retailerPrices - Type: string. Desc: JSON with retailer prices
 *
 * retailerProductId - Type: string. Desc: retailerProductId
 *
 * retailerStorePlatform - Type: string. Desc: retailer store platform
 *
 * retailerVariantIds - Type: string. Desc: List of retailer variants id
 *
 * searchTerm - Type: string. Desc: Search term by which user find this product (null if origin is product page or drafts list)
 *
 * shippingRate - Type: numeric. Desc: shipping Rate for retailer (main) country
 *
 * storeUrl - Type: string. Desc: site's url. Null for Wix users
 *
 * subscriptionPlanId - Type: string. Desc: package id in modalyst definition
 *
 * supplierId - Type: string. Desc: supplier_id
 *
 * variantsCount - Type: numeric. Desc: number of variants
 * @param {addProductToImportListClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addProductToImportListClicked = function (params) {
    return { evid: 5, src: 145, endpoint: 'modalyst', params: params };
};
/**
* @typedef {Object} exportToCsvClickedParams
* @property {string} accountId - modalyst account id
* @property {string} businessId - modalyst business id
* @property {string} correlationId - helps to connect between client and server events
* @property {string} instanceId - instanceId
* @property {boolean} isBulk - is bulk action
* @property {boolean} isDebug - is debug mode
* @property {boolean} isPremium - is modalyst premium
* @property {string} marketplace - RTS/POD
* @property {string} modalystProductId - modalyst_product_id
* @property {string} modalystVariantIds - List of variant ids
* @property {GUID} bi_token - wix msid
* @property {string} origin - Import list/synced products list
* @property {string} productName - product_name
* @property {string} retailerProductId - retailerProductId
* @property {string} retailerStorePlatform - retailer store platform
* @property {string} retailerVariantIds - List of retailer variants id
* @property {string} storeUrl - site's url. Null for Wix users
* @property {string} subscriptionPlanId - package id in modalyst definition
* @property {string} supplierId - supplier Id
* @property {string} supplierProductId - supplier ProductI d
* @property {number} variantsCount - Number of variants
**/
/**
 * Name: Export to CSV clicked. Evid: 10.
 * Event description: When user clicked to export cvs.

 * accountId - Type: string. Desc: modalyst account id
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * correlationId - Type: string. Desc: helps to connect between client and server events
 *
 * instanceId - Type: string. Desc: instanceId
 *
 * isBulk - Type: bool. Desc: is bulk action
 *
 * isDebug - Type: bool. Desc: is debug mode
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * marketplace - Type: string. Desc: RTS/POD
 *
 * modalystProductId - Type: string. Desc: modalyst_product_id
 *
 * modalystVariantIds - Type: string. Desc: List of variant ids
 *
 * bi_token - Type: guid. Desc: wix msid
 *
 * origin - Type: string. Desc: Import list/synced products list
 *
 * productName - Type: string. Desc: product_name
 *
 * retailerProductId - Type: string. Desc: retailerProductId
 *
 * retailerStorePlatform - Type: string. Desc: retailer store platform
 *
 * retailerVariantIds - Type: string. Desc: List of retailer variants id
 *
 * storeUrl - Type: string. Desc: site's url. Null for Wix users
 *
 * subscriptionPlanId - Type: string. Desc: package id in modalyst definition
 *
 * supplierId - Type: string. Desc: supplier Id
 *
 * supplierProductId - Type: string. Desc: supplier ProductI d
 *
 * variantsCount - Type: numeric. Desc: Number of variants
 * @param {exportToCsvClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var exportToCsvClicked = function (params) {
    return { evid: 10, src: 145, endpoint: 'modalyst', params: params };
};
/**
* @typedef {Object} productAddedToImportListParams
* @property {string} accountId - modalyst account id
* @property {string} businessId - modalyst business id
* @property {string} correlationId - correlation id to connect between client and server event
* @property {string} currency - currency
* @property {string} instanceId - instanceId
* @property {boolean} isDebug - is debug mode
* @property {boolean} isDynamicPrice - is_dynamic_price
* @property {boolean} isPremium - is modalyst premium
* @property {boolean} isShippingInCost - is_shipping_in_cost
* @property {string} itemsCost - JSON with variants origin prices
* @property {string} marketplace - RTS/POD
* @property {string} modalystProductId - modalyst_product_id
* @property {string} modalystVariantIds - List of variant ids
* @property {string} origin - PODeditor/draft list/product page
* @property {string} pageName - marketplace/product page
* @property {string} productDescription - productDescription
* @property {string} productName - productName
* @property {string} retailerPrices - JSON with retailer prices
* @property {string} retailerProductId - retailerProductId
* @property {string} retailerStorePlatform - retailer store platform
* @property {string} retailerVariantIds - List of retailer variants id
* @property {number} shippingRate - shipping_rate
* @property {string} storeUrl - site's url. Null for Wix users
* @property {string} subscriptionPlanId - package id in modalyst definition
* @property {string} supplierId - supplier_id
* @property {string} supplierProductId - supplier_product_id
* @property {number} variantsCount - variantsCount
**/
/**
 * Name: Product added to Import List. Evid: 1004.
 * Event description: Product added to Import List.

 * accountId - Type: string. Desc: modalyst account id
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * correlationId - Type: string. Desc: correlation id to connect between client and server event
 *
 * currency - Type: string. Desc: currency
 *
 * instanceId - Type: string. Desc: instanceId
 *
 * isDebug - Type: bool. Desc: is debug mode
 *
 * isDynamicPrice - Type: bool. Desc: is_dynamic_price
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * isShippingInCost - Type: bool. Desc: is_shipping_in_cost
 *
 * itemsCost - Type: string. Desc: JSON with variants origin prices
 *
 * marketplace - Type: string. Desc: RTS/POD
 *
 * modalystProductId - Type: string. Desc: modalyst_product_id
 *
 * modalystVariantIds - Type: string. Desc: List of variant ids
 *
 * origin - Type: string. Desc: PODeditor/draft list/product page
 *
 * pageName - Type: string. Desc: marketplace/product page
 *
 * productDescription - Type: string. Desc: productDescription
 *
 * productName - Type: string. Desc: productName
 *
 * retailerPrices - Type: string. Desc: JSON with retailer prices
 *
 * retailerProductId - Type: string. Desc: retailerProductId
 *
 * retailerStorePlatform - Type: string. Desc: retailer store platform
 *
 * retailerVariantIds - Type: string. Desc: List of retailer variants id
 *
 * shippingRate - Type: numeric. Desc: shipping_rate
 *
 * storeUrl - Type: string. Desc: site's url. Null for Wix users
 *
 * subscriptionPlanId - Type: string. Desc: package id in modalyst definition
 *
 * supplierId - Type: string. Desc: supplier_id
 *
 * supplierProductId - Type: string. Desc: supplier_product_id
 *
 * variantsCount - Type: numeric. Desc: variantsCount
 * @param {productAddedToImportListParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var productAddedToImportList = function (params) {
    return { evid: 1004, src: 145, endpoint: 'modalyst', params: params };
};
/**
* @typedef {Object} productUnSyncedParams
* @property {string} accountId - modalyst account id
* @property {string} businessId - modalyst business id
* @property {string} correlationId - correlation id to connect between client and server event
* @property {string} destination - Syncing process finished
* @property {string} externalRetailerProductId - External_retailer_product_id (wix product id)
* @property {string} instanceId - instanceId
* @property {boolean} isDebug - is debug mode
* @property {boolean} isPremium - is modalyst premium
* @property {string} marketplace - rts/pod
* @property {string} modalystProductId - modalyst_product_id
* @property {string} pageName - marketplace/product page
* @property {string} removalReason - removalReason
* @property {string} retailerProductId - retailer_product_id
* @property {string} retailerStorePlatform - retailer store platform
* @property {string} storeUrl - site's url. Null for Wix users
* @property {string} subscriptionPlanId - package id in modalyst definition
* @property {string} supplierId - supplier_id
* @property {string} supplierProductId - supplier_product_id
* @property {string} triggeredBy - Modalyst/wix - who triggered this process
**/
/**
 * Name: Product UnSynced. Evid: 1007.
 * Event description: Product UnSynced.

 * accountId - Type: string. Desc: modalyst account id
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * correlationId - Type: string. Desc: correlation id to connect between client and server event
 *
 * destination - Type: string. Desc: Syncing process finished
 *
 * externalRetailerProductId - Type: string. Desc: External_retailer_product_id (wix product id)
 *
 * instanceId - Type: string. Desc: instanceId
 *
 * isDebug - Type: bool. Desc: is debug mode
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * marketplace - Type: string. Desc: rts/pod
 *
 * modalystProductId - Type: string. Desc: modalyst_product_id
 *
 * pageName - Type: string. Desc: marketplace/product page
 *
 * removalReason - Type: string. Desc: removalReason
 *
 * retailerProductId - Type: string. Desc: retailer_product_id
 *
 * retailerStorePlatform - Type: string. Desc: retailer store platform
 *
 * storeUrl - Type: string. Desc: site's url. Null for Wix users
 *
 * subscriptionPlanId - Type: string. Desc: package id in modalyst definition
 *
 * supplierId - Type: string. Desc: supplier_id
 *
 * supplierProductId - Type: string. Desc: supplier_product_id
 *
 * triggeredBy - Type: string. Desc: Modalyst/wix - who triggered this process
 * @param {productUnSyncedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var productUnSynced = function (params) {
    return { evid: 1007, src: 145, endpoint: 'modalyst', params: params };
};
/**
* @typedef {Object} userProfileMenuTriggeredParams
* @property {string} accountId - modalyst account id
* @property {string} businessId - modalyst business id
* @property {string} correlationId - correlation_id
* @property {string} instanceId - instanceId
* @property {boolean} isDebug - is debug mode
* @property {boolean} isPremium - is modalyst premium
* @property {GUID} msid - msid
* @property {string} origin - main panel/ top actions
* @property {string} retailerStorePlatform - retailer store platform
* @property {string} storeUrl - site's url. Null for Wix users
* @property {string} subscriptionPlanId - package id in modalyst definition
* @property {string} uuid - uuid
**/
/**
 * Name: Modalyst Multi-stores: User Profile Clicked. Evid: 14.
 * Event description: User Profile Clicked.

 * accountId - Type: string. Desc: modalyst account id
 *
 * businessId - Type: string. Desc: modalyst business id
 *
 * correlationId - Type: string. Desc: correlation_id
 *
 * instanceId - Type: string. Desc: instanceId
 *
 * isDebug - Type: bool. Desc: is debug mode
 *
 * isPremium - Type: bool. Desc: is modalyst premium
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: main panel/ top actions
 *
 * retailerStorePlatform - Type: string. Desc: retailer store platform
 *
 * storeUrl - Type: string. Desc: site's url. Null for Wix users
 *
 * subscriptionPlanId - Type: string. Desc: package id in modalyst definition
 *
 * uuid - Type: string. Desc: uuid
 * @param {userProfileMenuTriggeredParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var userProfileMenuTriggered = function (params) {
    return { evid: 14, src: 145, endpoint: 'modalyst', params: params };
};
//# sourceMappingURL=index.js.map